{
  "heroic_approval": {
    "karma": "Karma",
    "setting_hint": "Shows your credited XP and karma when a good deed is confirmed."
  },
  "category_milestones": {
    "description": "Earn category XP, unlock titles and badges, and choose one title for your profile."
  },
  "level_up": {
    "setting": "Show character level-up popups"
  },
  "profile_identity": {
    "subtitle": "Your adventurer profile"
  },
  "adventureFlow": {
    "intro": "Your contribution counts. Real good deeds become an adventure that helps you and your community grow."
  },
  "flyers": {
    "adventurer": {
      "title": "Your adventure at a glance",
      "body": "Good deeds, experience, guilds and real benefits: the adventurer flyer shows you how Goodvale works. Download it and share it with friends.",
      "alt": "Preview of the Goodvale adventurer flyer"
    }
  },
  "partnersPage": {
    "intro": "Goodvale turns good deeds into an adventure: people help their communities, earn experience and rise through the ranks. Your business rewards that commitment with offers that give new customers a reason to discover you.",
    "example": "Example: your café offers 10% off from rank E, once per person per week.",
    "steps": [
      {
        "title": "Help & discover",
        "body": "Lea does good, reaches rank E and discovers your café and its offer in Goodvale."
      },
      {
        "title": "QR pass or digital",
        "body": "Lea presents her QR pass to be scanned. For a digital offer, she redeems it in the app and uses the provided code. Goodvale checks eligibility and limits."
      },
      {
        "title": "Enjoy the benefit",
        "body": "Your team confirms the on-site redemption and applies the discount at checkout: €10 becomes €9. The redemption is recorded."
      }
    ]
  },
  "class_change": {
    "current": "Your current class",
    "preview": "Your new class",
    "preview_hint": "Choose a class icon to explore its abilities and bonuses.",
    "xp_safe": "Your existing XP stays with you",
    "title": "Change class",
    "explanation": "You can change your class once within seven days of registration. Your existing XP and levels stay unchanged. Ongoing heroic actions keep their saved bonuses.",
    "choose": "Select a new class",
    "confirm": "Choose this class permanently? You cannot change your class again afterwards. Your existing XP will stay unchanged.",
    "save": "Use one-time class change",
    "success": "Your class has changed. Your existing XP is preserved.",
    "error": "Your class could not be changed.",
    "load_error": "Classes could not be loaded.",
    "used": "You have already used your one-time class change.",
    "unavailable": "Class changes are unavailable. You can only change class during your first seven days."
  },
  "ui_text": {
    "admin_dashboard": {
      "intro": "Aggregated live information on moderation, partner applications, guilds, users, and audit logs.",
      "guilds_stat": "Guilds",
      "active_guilds": "Active guilds in the game",
      "no_pending_deeds": "No good deeds are pending tribunal review.",
      "recent_users_intro": "Recently registered adventurers and profiles",
      "guilds_and_foundings": "Guilds & foundings",
      "guilds_intro": "Guild overview and Gildex points",
      "all_guilds": "All guilds",
      "no_guilds": "No guilds have been founded yet."
    },
    "admin_class_category": {
      "title": "Class & Category Configurator",
      "intro": "Configure hero classes, perks, good deed categories, and partner categories, including soft deletion.",
      "loading_classes": "Loading classes & perks...",
      "no_classes": "No classes available.",
      "general_xp_bonus": "General good deed XP bonus",
      "cooldown_reduction": "Good deed cooldown reduction"
    },
    "partner_offer_editor": {
      "map_intro": "Click the map or choose a quick option to set the location for adventurers.",
      "guild_category": "Guild category",
      "max_per_adventurer": "Max. redemptions per adventurer (optional)"
    },
    "guild_members_admin": {
      "banned_adventurers": "Banned adventurers",
      "loading_bans": "Loading banned adventurers...",
      "no_bans": "No active guild bans",
      "ban_adventurer": "Ban adventurer from guild",
      "ban_warning": "The adventurer will be removed from the guild immediately, and future join requests will be permanently blocked.",
      "ban_reason": "Reason for the guild (optional):"
    },
    "guild_branding": {
      "loading": "Loading guild branding...",
      "emblem_intro": "Design your guild emblem with a symbol, frame, wings, crest, base, and color scheme.",
      "details_title": "Guild details & public profile",
      "details_intro": "This information is visible to all adventurers on the guildhouse home page and overview.",
      "motto": "Guild motto & philosophy / description:",
      "location": "Guild location (coordinates): *"
    },
    "guild_detail_misc": {
      "back_to_guilds": "Back to guild overview",
      "ban_confirm": "Do you really want to permanently ban this member from the guild?",
      "sole_leader_warning": "You are the only guild leader. Appoint another member as a guild admin before leaving the guild."
    },
    "admin_tribunal_moderators": {
      "applications_intro": "New applications from adventurers of Rank C or higher appear here for approval or rejection."
    },
    "heroic_actions_misc": {
      "rules_slots_timing": "For individual actions, the cooldown starts when XP is awarded. For group actions, it runs from registration and does not restart when XP is awarded. “My slots” shows your current occupancy and remaining cooldowns."
    },
    "admin_heroic_actions": {
      "rank_f": "Rank F (Novice)",
      "rank_e": "Rank E (Explorer)",
      "rank_d": "Rank D (Pioneer)",
      "rank_c": "Rank C (Guardian)",
      "rank_b": "Rank B (Master)",
      "rank_a": "Rank A (Elite)",
      "rank_s": "Rank S (Legend)"
    },
    "game_mechanics_misc": {
      "view_classes_ranks": "View classes"
    },
    "guilds_misc": {
      "no_guild_intro": "You are not in a guild yet. Create your own guild or join a community!"
    }
  },
  "guild_rooms": {
    "hall": "Guild hall",
    "treasury": "Treasury",
    "shop": "Guild shop"
  },
  "hero_card": {
    "title": "Hero card",
    "karma": "Karma",
    "guild": "Guild",
    "qr": "Current hero pass"
  },
  "dialogs": {
    "moderator_title": "Join the tribunal"
  },
  "app": {
    "adventurer": "Adventurer {{name}}",
    "rank_class": "Rank {{rank}} • {{class}}"
  },
  "world": {
    "nav": {
      "guild": "Guild"
    }
  },
  "common": {
    "adventurer": "Adventurer",
    "rank": "Rank {{rank}}"
  },
  "nav": {
    "dashboard": "Adventurer ID",
    "talents": "Talents",
    "tavern": "Tavern",
    "guilds": "Guilds",
    "classes_ranks": "Classes & Ranks",
    "classes": "Classes",
    "ranks": "Ranks",
    "world_guild_mgmt": "Guild Management",
    "good_deeds": "Good deeds & XP"
  },
  "karma": {
    "title": "Karma · Trust",
    "subtitle": "Your code of conduct and standing in the World Guild.",
    "points": "{{score}} Karma Points",
    "open_barometer": "Open the karma bar in the profile",
    "markers_title": "Karma thresholds and requirements",
    "marker_guild": "Found a guild",
    "marker_guild_detail": "Minimum karma; rank and approved deeds are also required.",
    "marker_tribunal": "Tribunal application",
    "marker_tribunal_detail": "Minimum karma; Rank {{rank}} is also required.",
    "marker_neutral_detail": "No karma sanction.",
    "marker_partner_detail": "Applies from {{partner}} to {{minimum}} karma.",
    "marker_xp": "Daily XP deduction",
    "marker_xp_detail": "Applies from {{xp}} to {{xpEnd}}; {{percent}}% of total XP daily.",
    "marker_tribunal_loss": "Tribunal rights revoked",
    "marker_tribunal_loss_detail": "At {{tribunalLoss}}, an existing Tribunal role is removed.",
    "tier_trusty_desc": "Positive karma from regular, verified good deeds.",
    "tier_neutral_desc": "Balanced karma. Submit good deeds or support your guild.",
    "tier_warned_desc": "From {{partner}} karma, partner benefits are blocked. Verified good deeds rebuild trust.",
    "tier_outlaw": "Daily XP deduction",
    "tier_outlaw_desc": "From {{xp}} to {{xpEnd}} karma, {{percent}}% of your current total XP is deducted daily.",
    "tier_banned_desc": "Your account has been suspended separately, independently of karma.",
    "rules": "Karma ranges from {{minimum}} to {{maximum}}. At {{partner}} partner benefits are blocked, from {{xp}} {{percent}}% of total XP is deducted daily, and at {{suspension}} the account is suspended for {{months}} calendar month(s).",
    "tier_restricted_desc": "From {{suspension}} to {{minimum}} karma, your account is suspended for {{months}} calendar month(s). A separate admin suspension is unaffected.",
    "tier_released_desc": "The temporary account suspension has ended. Partner benefits remain blocked at this karma score.",
    "moderate": "Manage karma",
    "moderation_hint": "Guild admin deductions require system admin approval. After approval, the affected person sees your reason and name.",
    "deduction": "Karma deduction (1–100 points)",
    "submit": "Deduct karma & notify",
    "saved": "Karma deduction saved and notification created.",
    "pending_saved": "Karma deduction sent to a system admin for approval.",
    "pending_title": "Pending karma deductions",
    "pending_notification": "{{actor}} requested a {{points}} karma deduction for {{target}}.",
    "history": "Karma · Explained deductions",
    "no_penalties": "No karma deductions.",
    "scope": "Guild admins can manage members of their own guild. Superadmins can act across guilds.",
    "penalty_notification_title": "Your karma has changed",
    "penalty_notification": "{{actor}} adjusted your karma by {{delta}} points. New score: {{score}}. Reason: {{reason}}"
  },
  "tavern": {
    "detail": {
      "back": "Back to the tavern"
    },
    "feed": {
      "adventurer": "Adventurer: {{name}}",
      "guild": "Guild: {{name}}",
      "xpEarned": "+{{xp}} XP earned"
    },
    "title": "Tavern",
    "empty": "It's quiet in the tavern today.",
    "rank": "Rank {{rank}}"
  },
  "guilds": {
    "decorations": {
      "title": "Unlocked guild decorations"
    },
    "createModal": {
      "title": "Found a New Guild",
      "namePlaceholder": "Guild name (max. 60 characters)",
      "descPlaceholder": "Guild philosophy / description (optional, max. 300 characters)",
      "submit": "Found Guild",
      "nameRequired": "A guild name is required.",
      "nameTooLong": "Guild name may be at most 60 characters.",
      "locationTitle": "Guild location",
      "creating": "Creating guild…"
    },
    "createPage": {
      "basicInfoTitle": "1. Guild Details",
      "requirementsTitle": "Requirements to found a guild",
      "requirements": "At least rank {{rank}}, {{actions}} approved good deeds and {{karma}} karma. You must not already belong to a guild. After dissolving or transferring leadership of your guild, wait {{days}} days before founding another.",
      "requirementsIntro": "To found a guild, you need:",
      "rankProgress": "Rank {{required}} (current: {{current}})",
      "karmaProgress": "{{required}} karma (current: {{current}})",
      "cooldownUntil": "Leadership cooldown until {{date}}",
      "cooldownReady": "{{days}} day cooldown after dissolving or transferring your guild",
      "noGuildRequirement": "You must not already belong to another guild.",
      "requirementsUnavailable": "Guild founding requirements could not be loaded. Please try again later.",
      "requirementsLoading": "Loading guild founding requirements…",
      "forgeHint": "After founding your guild, you can unlock more emblem designs and colors in the guild shop's Banner Forge with Gildex."
    },
    "title": "Guild Center",
    "subtitle": "Find a guild or create your own.",
    "description": "Find a community that suits you. Discover guilds and make a difference together through good deeds.",
    "directory_title": "Guild Directory",
    "directory_intro": "Discover other guilds and join a community.",
    "founding_title": "Found your own guild",
    "clear_search": "Clear guild search",
    "pagination_label": "Guild directory pages",
    "empty": "No guilds available yet.",
    "loadError": "Failed to load guilds.",
    "create": "Create Guild",
    "yourGuild": "Your Guild",
    "yourGuildAdmin": "Your Guild (Admin)",
    "inOtherGuild": "In Other Guild",
    "back_to_guilds": "All guilds",
    "backToGuilds": "Back to guild directory",
    "ausgew_hltes_gildenw": "Selected guild emblem",
    "gildenhaus": "Guild hall",
    "entdecke_andere_gild": "Discover other guilds and join a community.",
    "du_bist_aktuell_in_k": "You are currently not in a guild. Start your own guild or join a community!",
    "gilde_suchen_placeholder": "Search guild..."
  },
  "share": {
    "subtitle": "Invite other adventurers to join the guild and explore the world!"
  },
  "pos": {
    "subtitle": "Scan adventurer passes, verify signatures, and evaluate on-site discounts in real time.",
    "standby_desc": "Hold an adventurer’s QR pass in front of the camera."
  },
  "profile_v2": {
    "progress_line": "Rank {{rank}} · Level {{level}} · {{xp}} XP",
    "preferences": "Appearance",
    "moderator_title": "Become a Tribunal Moderator",
    "moderator_help": "From Rank {{rank}} and {{karma}} karma, you can apply. Independent reviews are assigned only after admin approval.",
    "delete_confirm": "Do you really want to permanently anonymize your account? Evidence files and contact details will be deleted. If you are the last member of your guild, the guild will also be permanently deleted."
  },
  "map_v2": {
    "guilds": "Guilds"
  },
  "chats_v2": {
    "permission_guild": "People in my guild",
    "subtitle": "Private conversations between adventurers. Guild coordination belongs in guild chat.",
    "search": "Search adventurers …",
    "rank": "Rank {{rank}}",
    "rank_class": "Rank {{rank}} · {{heroClass}}"
  },
  "game_mechanics": {
    "groups": {
      "text": "Guild admins may announce voluntary, non-commercial group good deeds. Members register and confirm participation after the activity begins. The organizer allocates total XP among confirmed participants, with no more than 50% per person. The tribunal reviews the allocation. Partners may not turn these activities into concealed commercial work."
    },
    "removed": {
      "text": "There is no purchasable or transferable in-game currency. Progress is earned exclusively through approved good deeds and can neither be bought nor transferred between people. Guilds and partners do not issue paid assignments and receive no share of your experience. There are also no shortcuts for ranking up or tax-like game mechanics."
    },
    "ai_abuse": {
      "text": "Goodvale is built on genuine real-world actions and mutual trust. Misusing AI to generate, fabricate, or manipulate good deeds and evidence is strictly prohibited. Any detected AI abuse will be punished with negative karma and, if necessary, an account ban."
    },
    "karma": {
      "neutral": {
        "title": "No karma sanction"
      },
      "xp": {
        "title": "Additional daily XP deduction",
        "text": "Once per UTC day, {{percent}}% of current total XP is deducted. The percentage can be changed in system settings. Category XP stays intact; level and rank are recalculated."
      },
      "tribunal": {
        "title": "Tribunal rights revoked",
        "text": "At {{tribunalLoss}} karma, an existing Tribunal role is removed and a pending application is reset. Recovery requires a new application. Rank {{tribunalRank}} and at least {{tribunalMinimum}} karma are required; both values are configurable."
      },
      "suspension": {
        "text": "The account is suspended for {{months}} calendar month(s). No daily XP is deducted during that time. This karma suspension then ends automatically."
      },
      "title": "Karma in detail",
      "intro": "Karma starts at 0 and ranges from {{minimum}} to {{maximum}}. Approved good deeds raise it; a rejected or withdrawn deed alone does not lower it. Admins can deduct karma for misconduct with a stated reason.",
      "note": "The daily deduction rounds up to whole XP, stops at 0 XP, and appears in the XP ledger. After the suspension ends, karma below the partner threshold still blocks partner benefits. A separate admin suspension ends only when manually lifted. Approved good deeds can rebuild karma."
    },
    "subtitle": "Submit good deeds, have them independently reviewed, earn XP, and unlock matching partner offers.",
    "flow": [
      {
        "title": "1. Good deed",
        "description": "Describe a completed voluntary good deed and submit only the privacy-conscious evidence that is needed."
      },
      {
        "title": "2. Tribunal",
        "description": "The first review sets time and effort, planning and coordination, and XP. The XP amount determines whether one, two, or three independent reviews and an additional admin review are required."
      },
      {
        "title": "3. Progress",
        "description": "Only the final approval writes global and category XP to the immutable XP ledger. Level, rank, and category level are calculated from it."
      },
      {
        "title": "4. Partners",
        "description": "Offers may require rank, level, global XP, category XP, or an approved system good deed. Redemption uses a short-lived, signed, one-time QR pass."
      }
    ],
    "gildex": {
      "title": "Gildex and treasury",
      "text": "When a good deed is approved, the guild recorded at submission additionally receives a configurable share of base XP as Gildex. Player XP are not reduced. Gildex have no monetary value, cannot be purchased, cashed out or transferred, and are not accepted by partners. Guild admins may use them only for internal decorations and convenience features."
    },
    "perks": {
      "title": "Classes and talents",
      "items": [
        {
          "title": "More experience",
          "description": "Some classes and talents award extra XP after your good deed is approved."
        },
        {
          "title": "More at once",
          "description": "Extra slots let you work on several good deeds or group actions at the same time."
        },
        {
          "title": "Shorter wait",
          "description": "Certain abilities reduce the wait until your next submission."
        },
        {
          "title": "Achieve more together",
          "description": "A Bard raises XP for an approved group action by 10%. The bonus applies only once, even with several Bards."
        },
        {
          "title": "Category progress",
          "description": "Category XP helps you progress in the matching area. Your total XP is tracked separately."
        },
        {
          "title": "Improve karma",
          "description": "Some talents increase your karma after approved good deeds. Evidence review remains independent."
        },
        {
          "title": "Experience Elixir",
          "description": "As an Alchemist, you can use one free elixir per calendar week before an individual action. Approval awards 25% more total and category XP."
        }
      ]
    },
    "principles_title": "Principles & Guild Dynamics",
    "classes_link": "View all 10 classes",
    "start_description": "Choose your hero class, document your first voluntary contribution, and earn verified experience."
  },
  "player_progress": {
    "xp_value": "{{xp}} XP",
    "next_level_xp": "To next level: {{xp}} XP",
    "next_level_xp_short": "{{xp}} XP left"
  },
  "level_statistics": {
    "subtitle": "Level {{level}} · {{xp}} XP in total. Track your progress and the approved good deeds that earned your experience.",
    "xp_to_talent": "XP to next talent point",
    "talent_point_ready": "Talent point available",
    "talent_points_max": "All talent points earned",
    "xp": "XP",
    "monthly_xp": "XP this month",
    "zero": "0 XP",
    "no_history": "There has been no XP gain in the last twelve months yet.",
    "deeds_title": "Good deeds & XP earned",
    "no_deeds": "There are no approved good deeds with XP yet."
  },
  "slotsPage": {
    "cooldownFrom": "Cooldown from:",
    "skipSuccess": "Cooldown skipped. The slot is now free.",
    "skipError": "The cooldown could not be skipped.",
    "cooldown": "Cooldown",
    "groupCooldown": "Group cooldown"
  },
  "dashboard_v2": {
    "adventurer_kicker": "Goodvale · Adventurer",
    "free_adventurer": "Independent adventurer",
    "hero_class": "Hero class",
    "class": "Class",
    "class_category_bonus": "Class bonus +{{percent}}% XP",
    "other_category_bonus": "+{{percent}}% category XP",
    "next_talent_point": "Next talent point: Lv. {{level}}",
    "talent_stage": "Rank {{rank}}",
    "no_talents": "No talents unlocked yet",
    "reset_banner": "Restore class artwork",
    "talents_panel_title": "Your talents",
    "available_talent_points": "Available talent points",
    "open_talent_tree": "Open talent paths",
    "class_panel_title": "Class & specialization",
    "open_class_progress": "Open class and rank progress",
    "eyebrow": "Adventurer Hub",
    "subtitle": "Submit good deeds, follow tribunal decisions, and grow your character and category progress.",
    "go_to_guild": "Go to My Guild",
    "no_guild": "Not yet in a guild",
    "browse_guilds": "View Guilds",
    "open_tribunal": "Open Tribunal",
    "total_xp": "Total XP",
    "rank": "Rank",
    "class_and_rank": "{{heroClass}} · Rank {{rank}}",
    "xp_value": "{{xp}} XP",
    "karma": "Karma",
    "apply_moderator_help": "From Rank C, you can apply to conduct independent tribunal reviews.",
    "moderator_prompt": "Why would you like to become a tribunal moderator?",
    "status_PendingReview": "Tribunal Review"
  },
  "partner_offers": {
    "redemption_channel_help": "Choose where and how adventurers can redeem your offer.",
    "freq_once_ever": "Once per adventurer",
    "subtitle": "Choose which verified progress unlocks an offer. XP are not spent on redemption.",
    "empty_desc": "Create your first partner offer with a rank, XP, category, or heroic-action requirement.",
    "modal_subtitle": "Automatically evaluated at POS when scanning adventurers.",
    "req_karma": "Min. Karma: {{karma}}",
    "responsibility_confirmation": "I confirm that I am responsible for this offer's content, availability, and fulfillment. XP are not consumed, transferable, or worth money.",
    "form_rank": "Minimum Rank",
    "form_global_xp": "Total XP",
    "form_category_xp": "Category XP",
    "form_honor": "Minimum Karma",
    "req_rank": "Rank {{rank}} or higher",
    "req_global_xp": "{{xp}} Total XP",
    "req_category_xp": "{{xp}} XP in {{category}}",
    "category_required": "Select a category for the category-level or XP requirement."
  },
  "errors": {
    "medic_notice": " (incl. Cleric bonus +1 rank)",
    "merchant_notice": " (incl. Special / Talent bonus)"
  },
  "error": {
    "desc": "An unexpected error occurred. Our Tribunal has been notified automatically."
  },
  "register": {
    "field_contact": "Contact for adventurers",
    "field_contact_hint": "How adventurers can reach you (for example, phone, email or website).",
    "field_contact_required": "Please provide a contact for adventurers.",
    "role_adventurer": "Adventurer",
    "class": "Hero Class",
    "class_required": "Please select a class.",
    "class_title": "Choose your Class",
    "classesSubtitle": "Ten classes, one common goal: making real good deeds visible.",
    "class_hint": "Each class gains +20% global and category XP for approved actions in its category and a special class ability.",
    "class_hint_bold": "You can change your class once in your profile within the first seven days after registration. After that, your choice is final. Previously awarded XP stays unchanged.",
    "field_category_note": "Important for the adventurer class trigger system.",
    "class_scout": "Scout",
    "class_medic": "Cleric",
    "class_social": "Bard",
    "class_tank": "Tank",
    "class_environment": "Druid",
    "class_tech": "Mage",
    "class_crafter": "Smith",
    "class_nutrition": "Alchemist",
    "class_logistics": "Merchant",
    "class_guardian": "Paladin",
    "classes_loading": "Loading class abilities …",
    "classes_error": "Could not load class abilities. Please try again."
  },
  "login": {
    "subtitle": "Login for Adventurers and Partners"
  },
  "public_profile": {
    "bio_title": "About this Adventurer",
    "no_bio": "This adventurer has not set a public bio yet.",
    "karma_score": "Karma Score",
    "rank": "Rank {{rank}}",
    "visitor_title": "Adventurer profile"
  },
  "location_picker": {
    "hint": "Click the location of your business or guild. This location will be publicly visible on the world map."
  },
  "admin_partners": {
    "nav_title": "Partners & Requests",
    "title": "Partners & Partner Requests",
    "loading": "Loading partner requests …",
    "empty": "No pending partner requests."
  },
  "admin_nav": {
    "tribunal_moderators": "Tribunal Moderators",
    "karma": "Karma Management",
    "class_categories": "Classes, Perks & Categories",
    "heroic_actions": "Tribunal",
    "xp_audits": "XP review",
    "guild_hall": "Guild Hall Editor"
  },
  "xp_audit": {
    "title": "XP alerts",
    "intro": "Review XP earned quickly. Held rewards do not affect rank or progress until a decision is made.",
    "recent_awards": "Recent XP entries",
    "player_pending": "XP held for admin review",
    "approve": "Release XP",
    "reject": "Reject XP",
    "load_error": "Could not load XP review cases."
  },
  "admin_tribunal_moderators": {
    "title": "Tribunal Moderators & Applications",
    "subtitle": "Review open applications from adventurers from Rank C and manage active tribunal moderation permissions.",
    "no_moderators": "No tribunal moderators are currently active.",
    "revoke_confirm_text": "Are you sure you want to revoke tribunal moderation permissions for {{name}}? They will no longer be able to review good deeds."
  },
  "admin_karma": {
    "pending_empty": "No pending requests.",
    "deduct_error": "Failed to deduct karma.",
    "award_error": "Failed to award karma.",
    "unknown_user": "Adventurer",
    "pending_title": "Requests from guild admins",
    "title": "Karma Management",
    "scope_hint": "Superadmins can manage karma for all accounts, deduct or award points, and review full audit history.",
    "filter_restricted": "XP deduction or suspension (≤ {{xp}})",
    "manage_btn": "Manage Karma",
    "current_score": "Current Karma Score",
    "tier_xp_penalty": "Daily XP deduction",
    "tab_deduct": "Deduct Karma (Penalty)",
    "tab_award": "Award Karma (Bonus)",
    "tab_history": "Karma History",
    "deduct_desc": "Decreases the user's karma. Required justification is logged in audit log and sent via notification.",
    "award_desc": "Increases the user's karma for exceptional merit or adjustments.",
    "submit_deduct": "Deduct Karma & Notify User",
    "submit_award": "Award Karma & Notify User",
    "deduct_success": "Karma deduction saved successfully ({{delta}} points).",
    "award_success": "Karma award saved successfully (+{{delta}} points).",
    "history_empty": "No karma records found for this user.",
    "history_title": "Audit Log & Karma Changes",
    "rules_summary_title": "Karma System Rules",
    "rules_threshold": "At {{partner}} partner block; {{xp}} to {{xpEnd}} {{percent}}% XP deducted daily; at {{tribunal}} Tribunal rights revoked; at {{suspension}} account suspended for {{months}} calendar month(s)",
    "rules_recovery": "Verified good deeds gradually rebuild karma"
  },
  "admin_settings": {
    "filter_heroic_actions": "Good Deeds & XP Ranges",
    "filter_progression": "Ranks & Progression"
  },
  "admin_events": {
    "form_ep_multi": "XP Multiplier",
    "multiplier_hint": "1 = no XP bonus, 1.5 = +50% XP, 2 = double XP.",
    "rewards_hint": "Additional event karma (0–100). The actual reward is awarded when the submitted action is reviewed.",
    "global_impact_desc": "Events temporarily override system multipliers for all players worldwide. They are the most powerful tool of the Guild Master to steer volunteers towards specific sectors."
  },
  "access": {
    "unauthorized_back_dashboard": "Back to Adventurer Dashboard",
    "role_adventurer": "Adventurer",
    "role_guildadmin": "Guild Admin"
  },
  "nav_cross": {
    "goto_adventurer_dashboard": "Go to Adventurer Dashboard",
    "tooltip_dual_role": "You are also an Adventurer"
  },
  "guild": {
    "public_about": "About our guild",
    "public_navigation": "Explore the guild",
    "already_in_guild_hint": "You can only belong to one guild. Leave your current guild first.",
    "leave": "Leave guild",
    "leave_confirm": "Are you sure you want to leave this guild?",
    "disband_confirm": "You are the last member of {{name}}. Leaving will permanently delete the guild. Do you want to disband it?",
    "successor_warning": "Choose a member to take over guild leadership before you leave. The guild will remain active.",
    "leave_error": "Could not leave guild.",
    "own_house": "Your guild hall",
    "public_house": "Public guild hall",
    "detail_description": "Your shared good deeds leave their mark. As your guild renown grows, your hall becomes more magnificent.",
    "tab_news": "Guild News",
    "tab_stammtisch": "Guild Common Table",
    "gildex_treasury": "Guild Treasury",
    "unlocked_emotes": "Guild Emotes",
    "news_title": "Guild News & Announcements",
    "news_subtitle": "Official system messages and administrative announcements for all guild members.",
    "news_editor_title": "Write a guild announcement",
    "news_title_placeholder": "e.g. Next guild meeting and good deed focus …",
    "news_content_placeholder": "Share all important information with your guild members …",
    "news_publish_success": "Announcement published in guild news.",
    "news_loading": "Loading guild news …",
    "news_system_author": "System · Guild Headquarters",
    "no_news_desc": "Guild admins can publish official announcements here.",
    "stammtisch_title": "Guild Common Table",
    "chat_empty_description": "Welcome your guild members or talk about your adventures.",
    "chat_rank": "Rank {{rank}}",
    "chat_poll_question": "Ask your guild a question",
    "chat_action_failed": "Could not update guild chat.",
    "more_emotes_hint": "Common Table Plus in Guild Shop",
    "emote_cat_guild": "Guild",
    "emote_cat_tavern": "Tavern",
    "admins_title": "Guild Admins:",
    "leader_title": "Guild Leader:",
    "admin_badge": "Guild Admin",
    "promote_admin_title": "Promote to Guild Admin",
    "promote_confirm": "Do you want to promote \"{{name}}\" to Guild Admin?",
    "promote_success": "\"{{name}}\" has been successfully promoted to Guild Admin."
  },
  "notifications": {
    "heroic_action": {
      "approved_message": "Your good deed ‘{{title}}’ was approved. +{{xp}} XP.",
      "review_assigned_title": "New tribunal review",
      "appeal_approved_message": "The good deed will be reviewed in a new, independent tribunal round."
    },
    "group_action": {
      "invited_message": "Your guild admin invited you to {{title}}. Open your guild's group good deeds to register voluntarily.",
      "announced_message": "Your guild announced ‘{{title}}’. Registration is open.",
      "approved_message": "‘{{title}}’ was approved. Your share: +{{xp}} XP."
    },
    "xp_audit": {
      "pending_title": "XP under review",
      "pending_message": "‘{{title}}’ was approved. XP is held for admin review because of rapid XP gains.",
      "released_title": "XP released",
      "released_message": "Admin review is complete. +{{xp}} XP has been credited.",
      "rejected_title": "XP not released",
      "rejected_message": "Admin review did not release {{xp}} held XP."
    },
    "guild_app_approved": {
      "title": "Guild Join Approved!",
      "message": "Congratulations! Your join request for the guild '{{guildName}}' was accepted."
    },
    "guild_app_denied": {
      "title": "Guild Join Rejected",
      "message": "Your join request for the guild '{{guildName}}' was unfortunately rejected."
    },
    "promotion": {
      "title": "Promoted to Guild Admin!",
      "message": "Congratulations! You have been promoted to Guild Admin."
    }
  },
  "talents": {
    "branches": {
      "A": {
        "subtitle": "Shorter waits, more submissions, and Gildex"
      },
      "B": {
        "subtitle": "More total XP, category XP, and karma"
      },
      "C": {
        "subtitle": "Strengthen karma and group actions"
      }
    },
    "skills": {
      "A_HEROIC_ACTION_SPONSOR": {
        "title": "Guild Patron",
        "rank1_value": "+10% Gildex",
        "rank2_value": "+20% Gildex",
        "rank3_value": "+30% Gildex",
        "rank1": "Stage 1: Your approved good deeds give your guild 10% more Gildex.",
        "rank2": "Stage 2: Your approved good deeds give your guild 20% more Gildex.",
        "rank3": "Stage 3: Your approved good deeds give your guild 30% more Gildex."
      },
      "B_TREASURE_HUNTER": {
        "rank1_value": "+5% total XP",
        "rank2_value": "+10% total XP",
        "rank3_value": "+15% total XP",
        "rank1": "Stage 1: You earn 5% more total XP from approved good deeds.",
        "rank2": "Stage 2: You earn 10% more total XP from approved good deeds.",
        "rank3": "Stage 3: You earn 15% more total XP from approved good deeds."
      },
      "B_BARTERER": {
        "rank1_value": "+5% category XP",
        "rank2_value": "+10% category XP",
        "rank3_value": "+15% category XP",
        "rank1": "Stage 1: You earn 5% more category XP from approved good deeds.",
        "rank2": "Stage 2: You earn 10% more category XP from approved good deeds.",
        "rank3": "Stage 3: You earn 15% more category XP from approved good deeds."
      },
      "B_VERIFIED_PROOF": {
        "rank1_value": "+1 karma",
        "rank2_value": "+2 karma",
        "rank3_value": "+3 karma",
        "rank1": "Stage 1: An approved good deed gives you 1 additional karma point.",
        "rank2": "Stage 2: An approved good deed gives you 2 additional karma points.",
        "rank3": "Stage 3: An approved good deed gives you 3 additional karma points."
      },
      "C_RESILIENCE": {
        "rank1_value": "up to +1 karma",
        "rank2_value": "up to +2 karma",
        "rank3_value": "up to +3 karma",
        "rank1": "Stage 1: If your karma is negative, an approved good deed restores up to 1 extra karma points, never above zero.",
        "rank2": "Stage 2: If your karma is negative, an approved good deed restores up to 2 extra karma points, never above zero.",
        "rank3": "Stage 3: If your karma is negative, an approved good deed restores up to 3 extra karma points, never above zero."
      },
      "C_GROUP_MENTOR": {
        "rank1_value": "+5% group XP",
        "rank2_value": "+10% group XP",
        "rank3_value": "+15% group XP",
        "rank1": "Stage 1: Your contribution increases XP for an approved group action by 5%.",
        "rank2": "Stage 2: Your contribution increases XP for an approved group action by 10%.",
        "rank3": "Stage 3: Your contribution increases XP for an approved group action by 15%."
      },
      "C_GUILD_BENEFACTOR": {
        "rank1_value": "+1 karma",
        "rank2_value": "+2 karma",
        "rank3_value": "+3 karma",
        "rank1": "Stage 1: An approved group action gives you 1 additional karma point.",
        "rank2": "Stage 2: An approved group action gives you 2 additional karma points.",
        "rank3": "Stage 3: An approved group action gives you 3 additional karma points."
      }
    },
    "stats": {
      "cooldown": {
        "label": "Cooldown",
        "description": "Receiving a reward starts the cooldown for that slot. For active group quests, it starts at registration. Withdrawal or cancellation releases the slot. Combined bonuses can reduce the wait by up to 80%."
      },
      "xp_bonus": {
        "label": "Total XP",
        "description": "Extra total XP for confirmed individual actions. The class bonus applies in the matching category."
      },
      "cat_xp_bonus": {
        "label": "Category XP",
        "description": "Extra XP in the category of your confirmed individual action. General XP bonuses also apply."
      },
      "gildex": {
        "label": "Gildex",
        "description": "Your guild receives extra Gildex for confirmed individual actions. You keep all your XP.",
        "base_xp": "{{percent}}% of base XP"
      },
      "karma_rec": {
        "label": "Karma recovery",
        "description": "With negative karma, confirmed good deeds restore extra points, up to zero.",
        "talent": "+{{value}} karma (max +3, only with negative karma)"
      },
      "party_ep": {
        "label": "Group XP",
        "description": "Confirmed group actions grant more XP. The strongest class bonus applies once; talent bonuses are added."
      },
      "talent_rank": "Talent rank {{rank}}/3",
      "talent": "Talent",
      "class": "Class",
      "class_bonus": "Class bonus",
      "talent_points": "Talent points",
      "honor_heading": "Honor & karma",
      "xp_passive": "+{{percent}}% (max +10%: guild +5%, upgrade +5%)",
      "karma_value": "+{{value}} karma",
      "karma_bonus": {
        "label": "Karma bonus",
        "description": "Extra karma you receive for a confirmed good deed. Your total karma follows the current system limit.",
        "base": "0 extra karma",
        "talent": "+{{value}} karma (max +3)"
      },
      "group_karma": {
        "label": "Group karma",
        "description": "Extra karma you receive for confirmed group actions.",
        "base": "0 extra group karma",
        "talent": "+{{value}} karma (max +3)"
      }
    },
    "ui": {
      "xp_progress": "XP {{current}} / {{required}}",
      "xp_progress_aria": "Progress to next talent point in XP",
      "all_points_reached": "All talent points reached",
      "upgrade_success": "Talent rank upgraded successfully!",
      "upgrade_failed": "The talent could not be upgraded.",
      "tier_requirement": "Previous talent at stage 2",
      "not_unlocked_yet": "Not learned yet. Unlock rank 1 to activate this bonus.",
      "rank_badge": "Rank {{current}} / {{max}}",
      "max_rank_reached": "✓ Maximum Rank Reached (3/3)",
      "upgrade_to_rank": "Upgrade to Rank {{rank}} (1 Pt)",
      "unlock_rank_1": "Unlock Rank 1 (1 Pt)",
      "prereq_required": "First raise the previous talent to stage 2.",
      "points_required": "You need an available talent point.",
      "next_rank": "Next Rank ({{rank}}/{{max}}): {{desc}}",
      "footer_tip": "Tip: Each rank upgrade (Rank 1 to 3) permanently boosts your hero bonuses.",
      "loading": "Loading talent trees...",
      "error_load": "Error loading talent trees.",
      "origin_title": "Adventurer Focus",
      "origin_subtitle": "Central Talent Origin",
      "skill_tree_nav": "Select a circle to inspect the skill and its rank path",
      "progression_path": "Talent stages",
      "current_stage": "Current Rank",
      "next_stage": "Next Rank"
    },
    "tree": {
      "rank": "Rank {{rank}}",
      "requires_rank": "Previous talent: stage {{rank}}"
    },
    "title": "Your talents",
    "description": "As you gain levels, you earn talent points. Use them to unlock bonuses for experience, group actions, and future submissions.",
    "path_subtitles": {
      "A": "Submissions/Gildex",
      "B": "XP and karma",
      "C": "Karma and group"
    }
  },
  "categories": {
    "ENTERTAINMENT_GASTRO": "Entertainment & Gastro",
    "LOGISTICS_RETAIL": "Logistics & Retail",
    "TECH_EDUCATION": "Tech & Education",
    "ECO_NATURE": "Eco & Nature",
    "HEALTH_WELLNESS": "Health & Wellness",
    "MOBILITY_OUTDOOR": "Mobility & Outdoor",
    "CRAFTING_REPAIR": "Crafting & Repair",
    "FOOD_GROCERIES": "Food & Groceries",
    "HARDWARE_FITNESS": "Fitness & equipment"
  },
  "classes": {
    "roles": {
      "SCOUT": "Mobility & Outdoor",
      "MEDIC": "Health & Wellness",
      "SOCIAL": "Entertainment & Gastro",
      "TANK": "Fitness & equipment",
      "ENVIRONMENT": "Eco & Nature",
      "TECH": "Tech & Education",
      "CRAFTER": "Crafting & Repair",
      "NUTRITION": "Food & Groceries",
      "LOGISTICS": "Logistics & Retail"
    },
    "perks": {
      "SCOUT": "Approved good deeds in Mobility & Outdoor earn 20% more total and category XP. You wait 10% less time between submissions.",
      "MEDIC": "Approved good deeds in Health & Wellness earn 20% more total and category XP. While your karma is negative, each approved good deed restores one extra karma point, up to zero.",
      "SOCIAL": "Approved good deeds in Entertainment & Hospitality earn 20% more total and category XP. Approved group actions award 10% more XP to the group. The bonus applies only once, even with several Bards.",
      "TANK": "Approved good deeds in Fitness & Equipment earn 20% more total and category XP. You can submit one additional good deed at the same time.",
      "ENVIRONMENT": "Approved good deeds in Environment & Nature earn 20% more total and category XP. Your approved individual actions give your guild 20% more Gildex.",
      "TECH": "Approved good deeds in Tech & Education earn 20% more total and category XP. Approved good deeds outside Tech & Education award 10% more XP in their category.",
      "CRAFTER": "Approved good deeds in Crafting & Repair earn 20% more total and category XP. You can revise one rejected individual action and submit it for review once more.",
      "NUTRITION": "Approved good deeds in Food & Groceries earn 20% more total and category XP. Once per calendar week, you can activate a free Experience Elixir before an individual action. If approved, it gives 25% more total and category XP.",
      "LOGISTICS": "Approved good deeds in Logistics & Retail earn 20% more total and category XP. Once per calendar week, you can skip the wait until your next submission. You still need a free slot.",
      "GUARDIAN": "Approved good deeds in Social & Community earn 20% more total and category XP. Every approved good deed grants one extra karma point, including group actions.",
      "default": "Main Class Special Ability"
    }
  },
  "perks": {
    "titles": {
      "CLASS_V2_GUARDIAN_ABILITY": "Extra karma",
      "CLASS_V2_NUTRITION_ABILITY": "Experience Elixir",
      "CLASS_V2_TECH_ABILITY": "More XP in other categories",
      "CLASS_V2_ENVIRONMENT_ABILITY": "More Gildex for your guild",
      "CLASS_V2_MEDIC_ABILITY": "Restore karma faster"
    },
    "CLASS_V2_SCOUT_CATEGORY": "Approved good deeds in Mobility & Outdoor earn 20% more total and category XP.",
    "CLASS_V2_TANK_CATEGORY": "Approved good deeds in Fitness & Equipment earn 20% more total and category XP.",
    "CLASS_V2_GUARDIAN_CATEGORY": "Approved good deeds in Social & Community earn 20% more total and category XP.",
    "CLASS_V2_GUARDIAN_ABILITY": "Every approved good deed grants one extra karma point, including group actions.",
    "CLASS_V2_CRAFTER_CATEGORY": "Approved good deeds in Crafting & Repair earn 20% more total and category XP.",
    "CLASS_V2_SOCIAL_CATEGORY": "Approved good deeds in Entertainment & Hospitality earn 20% more total and category XP.",
    "CLASS_V2_SOCIAL_ABILITY": "Approved group actions award 10% more XP to the group. The bonus applies only once, even with several Bards.",
    "CLASS_V2_LOGISTICS_CATEGORY": "Approved good deeds in Logistics & Retail earn 20% more total and category XP.",
    "CLASS_V2_NUTRITION_CATEGORY": "Approved good deeds in Food & Groceries earn 20% more total and category XP.",
    "CLASS_V2_NUTRITION_ABILITY": "Once per calendar week, you can activate a free Experience Elixir before an individual action. If approved, it gives 25% more total and category XP.",
    "CLASS_V2_TECH_CATEGORY": "Approved good deeds in Tech & Education earn 20% more total and category XP.",
    "CLASS_V2_TECH_ABILITY": "Approved good deeds outside Tech & Education award 10% more XP in their category.",
    "CLASS_V2_ENVIRONMENT_CATEGORY": "Approved good deeds in Environment & Nature earn 20% more total and category XP.",
    "CLASS_V2_ENVIRONMENT_ABILITY": "Your approved individual actions give your guild 20% more Gildex.",
    "CLASS_V2_MEDIC_CATEGORY": "Approved good deeds in Health & Wellness earn 20% more total and category XP.",
    "CLASS_V2_MEDIC_ABILITY": "While your karma is negative, each approved good deed restores one extra karma point, up to zero."
  },
  "api": {
    "guild_unlock": {
      "already_unlocked": "This guild upgrade is already unlocked.",
      "insufficient_gildex": "The guild treasury does not have enough Gildex for this upgrade.",
      "requires_previous_boost": "Unlock the previous XP Boost first."
    },
    "messages": {
      "guild_statistics_members_only": "Only members of this guild can access its statistics.",
      "guild_founding_rank_required": "You need at least rank {{rank}} to found a guild.",
      "guild_founding_actions_required": "You need at least {{count}} approved good deeds to found a guild.",
      "guild_founding_karma_required": "You need at least {{karma}} karma to found a guild.",
      "guild_founding_cooldown": "Wait {{days}} days after your last guild leadership ended before founding another guild.",
      "settings_rank_requirement_invalid": "The minimum rank must be F, E, D, C, B, A, or S.",
      "settings_karma_requirement_invalid": "Minimum karma must be within the current karma limits and above the Tribunal revocation threshold.",
      "settings_karma_threshold_order_invalid": "Karma thresholds must remain in order (suspension, Tribunal revocation, XP deduction, partner block, positive tiers).",
      "settings_karma_xp_penalty_invalid": "Daily karma XP deduction must be between 0 and 100 percent.",
      "guild_applicant_unavailable": "The applicant can no longer join a guild.",
      "heroic_xp_audit_pending": "The pending XP audit must be decided first.",
      "heroic_xp_balance_mismatch": "The XP ledger does not match the current balance. The submission was not deleted.",
      "heroic_recalculate_admin_only": "Only active system administrators can recalculate XP.",
      "heroic_tribunal_assessment_missing": "The original tribunal assessment is missing.",
      "heroic_xp_ledger_missing": "The original XP ledger entry is missing for this submission.",
      "heroic_xp_participants_mismatch": "The XP ledger no longer matches the confirmed participants.",
      "heroic_xp_negative_balance": "The XP adjustment would create a negative balance.",
      "heroic_return_reviewer_only": "Only active tribunal moderators or system administrators can return submissions.",
      "class_change_unavailable": "The one-time class change is no longer available or is not allowed for this account.",
      "class_change_same": "Please choose a different class. Your one-time change has not been used.",
      "class_change_invalid": "This class is unavailable. Your one-time change has not been used.",
      "benutzer_erfolgreich_aus_der_g_38": "User banned from the guild successfully.",
      "gilden_sperre_erfolgreich_aufg_40": "Guild ban lifted successfully.",
      "gilden_wappen_erfolgreich_hochgeladen": "Guild emblem uploaded and updated successfully.",
      "gildenname_ist_erforderlich_un_23": "The guild name is required and must not exceed 60 characters.",
      "gildenstandort_breiten_und_l_n_25": "The guild location (latitude and longitude) is required.",
      "heldenklasse_erfolgreich_archi_8": "Hero class archived successfully.",
      "heldenklasse_erfolgreich_wiede_9": "Hero class restored successfully.",
      "keine_aktive_gilden_sperre_f_r_39": "No active guild ban was found for this user.",
      "klassen_perk_erfolgreich_archi_12": "Class perk archived successfully.",
      "klassen_perk_erfolgreich_wiede_13": "Class perk restored successfully.",
      "mitglied_erfolgreich_aus_der_g_36": "Member removed from the guild successfully.",
      "mitglied_erfolgreich_zum_gilde_46": "Member promoted to guild administrator successfully.",
      "mitglied_nicht_in_dieser_gilde_35": "Member not found in this guild.",
      "mitglied_nicht_in_dieser_gilde_45": "Member not found in this guild.",
      "nur_gilden_administratoren_d_31": "Only guild administrators may view membership applications.",
      "nur_gilden_administratoren_d_32": "Only guild administrators may process membership applications.",
      "nur_verifizierte_mitglieder_di_31": "Only verified members of this guild may access the guild chat.",
      "nur_verifizierte_mitglieder_di_32": "Only verified members of this guild may post in the guild chat.",
      "nur_verifizierte_mitglieder_di_33": "Only verified members of this guild may access guild news.",
      "talent_erfolgreich_freigeschaltet": "Talent unlocked successfully.",
      "guild_successor_required": "Appoint another guild leader before leaving the guild.",
      "guild_disband_confirmation_required": "Confirm disbanding the guild before leaving as its last member.",
      "heroic_cooldown_active": "You can start another good deed after the {{minutes}} minute cooldown.",
      "heroic_base_xp_range": "Base XP must be between {{minimum}} and {{maximum}} for this rating.",
      "heroic_category_xp_range": "Category XP must be between {{minimum}} and {{maximum}} for this rating.",
      "class_perk_hero_class_not_found": "The hero class was not found.",
      "class_perk_not_found": "The class perk was not found.",
      "admin_delta_range": "The adjustment must be between −100 and +100; the current system limits apply to the karma score.",
      "heroic_group_resubmit_in_guild": "Create a withdrawn group action again through the guild hall.",
      "heroic_review_moderator_only": "Only tribunal moderators can view open good deeds.",
      "heroic_reviewer_role_required": "Only approved tribunal moderators or administrators can review.",
      "heroic_appeal_reviewer_conflict": "The person who decided the appeal cannot review the new tribunal round.",
      "heroic_review_guild_conflict": "You cannot review a fellow guild member's good deed.",
      "heroic_review_same_player_cooldown": "Wait for the review cooldown before reviewing this player again.",
      "heroic_first_review_xp_required": "Set base and category XP in the first review, including rejections.",
      "heroic_moderator_rank_required": "Your rank is below the current minimum for a Tribunal application.",
      "heroic_moderator_karma_required": "Your karma is below the current minimum for a Tribunal application.",
      "heroic_already_moderator": "You are already a tribunal moderator.",
      "heroic_appeal_guild_conflict": "You cannot decide an appeal from a fellow guild member.",
      "heroic_adventurers_only": "Only adventurers can use this feature.",
      "partner_qr_requires_approved_hero": "Only approved adventurers can create a QR pass.",
      "partner_offer_rank_invalid": "Choose a valid minimum rank.",
      "direct_chat_contact_restricted": "You can message guildmates or people with a pending guild application.",
      "settings_xp_range_key_invalid": "Choose a valid good deed XP range key.",
      "settings_xp_range_value_invalid": "XP ranges must be whole numbers between 0 and 100,000.",
      "settings_xp_range_order_invalid": "The minimum XP cannot exceed the maximum XP.",
      "settings_gildex_rate_invalid": "The Gildex rate must be between 0 and 100 percent.",
      "talent_not_found": "This talent does not exist.",
      "talent_max_level": "This talent is already at its maximum level of 3/3.",
      "talent_no_points": "You have no talent points left.",
      "guild_chat_locked": "Unlock the guild chat at the Gildex first.",
      "guild_chat_members_only": "Only guild members can use guild chat.",
      "guild_emotes_locked": "Unlock the guild chat and emote pack first.",
      "guild_pin_admin_only": "Only guild administrators can pin messages.",
      "guild_news_title_required": "Enter a title for the guild news post.",
      "guild_news_content_required": "Enter content for the guild news post.",
      "guild_news_admin_only": "Only guild administrators can create news posts.",
      "guild_news_remove_admin_only": "Only guild administrators can remove news posts.",
      "guild_cannot_kick_self": "You cannot remove yourself from the guild.",
      "guild_kick_admin_only": "Only guild administrators can remove members.",
      "guild_cannot_kick_system_admin": "System administrators cannot be removed from a guild.",
      "guild_cannot_ban_self": "You cannot ban yourself from the guild.",
      "guild_ban_admin_only": "Only guild administrators can ban members.",
      "guild_cannot_ban_system_admin": "System administrators cannot be banned from a guild.",
      "guild_unban_admin_only": "Only guild administrators can lift bans.",
      "guild_bans_admin_only": "Only guild administrators can view banned members.",
      "guild_edit_admin_only": "Only guild administrators can edit guild details.",
      "guild_not_found": "The guild was not found.",
      "guild_emblem_admin_only": "Only guild administrators can change the emblem.",
      "guild_not_member": "You are not a member of this guild.",
      "guild_promote_admin_only": "Only guild administrators can promote members.",
      "guild_deputy_locked": "Unlock additional guild administrators at the Gildex first.",
      "guild_unlock_not_found": "The guild upgrade was not found.",
      "guild_gildex_admin_only": "Only guild administrators can spend Gildex.",
      "guild_treasury_members_only": "Only guild members can view the treasury.",
      "group_action_members_only": "Only members of this guild can access this action.",
      "group_action_active_members_only": "Only active guild members can participate.",
      "group_action_admin_only": "Only guild administrators can manage group actions.",
      "group_action_locked": "Unlock group actions at the Gildex first.",
      "group_action_cooldown_active": "You can start another good deed after the cooldown ends.",
      "guild_already_founded": "You have already founded a guild and cannot found another one.",
      "guild_membership_exists": "You already belong to a guild. Leave it before founding a new one.",
      "guild_already_member": "You already belong to a guild.",
      "guild_name_taken": "This guild name is already taken. Choose another name.",
      "partner_contact_required": "Provide a contact for adventurers with no more than 250 characters.",
      "karma_minimum": "The minimum karma score has already been reached.",
      "karma_maximum": "The maximum karma score has already been reached.",
      "account_suspended_karma": "This account was suspended because its karma is {{karma}} (suspension threshold: {{threshold}}). The temporary suspension ends on {{until}}.",
      "karma_partner_restricted": "Partner benefits are unavailable for suspended accounts or negative karma.",
      "karma_minimum_not_met": "Your karma is below the minimum required for this offer.",
      "heroic_cooldown_slot_unavailable": "This cooldown slot is no longer active. Please refresh the page.",
      "ungueltige_rolle": "Registration is only permitted as an Adventurer or Partner.",
      "ungueltige_heldenklasse": "The selected hero class is invalid.",
      "invalid_gildex_price": "The Gildex price must be a nonnegative integer.",
      "account_successor_required": "Transfer guild leadership to another member before deleting your account.",
      "group_xp_allocation_missing": "Please set the XP allocation.",
      "group_xp_allocation_incomplete": "The saved XP allocation is incomplete.",
      "group_xp_allocation_approval": "Please explicitly approve the organizer’s XP allocation.",
      "group_xp_allocation_stale": "The review round has changed. Reload the action and review its current XP allocation."
    },
    "status": {
      "429": "Too many requests. Please wait a moment."
    }
  },
  "faq_page": {
    "subtitle": "Good deeds, tribunal, XP, guilds, partners, and privacy",
    "sections": [
      [
        "Good Deeds & XP",
        [
          [
            "How does Goodvale work?",
            "You self-report a good deed you actually performed, describe it, and submit encrypted evidence unless an eligible self-report applies. The tribunal reviews it independently. Global and category XP are credited only after final verification."
          ],
          [
            "How much XP is appropriate?",
            "Admin settings define six individual bands and eight separate group bands. Current group pools range from {{groupBand1}} XP in band 1 to {{groupBand8}} XP in band 8, before bonuses and allocation. The following examples show individual values. Time and effort reflect time, strain, and responsibility; planning and coordination reflect planning, coordination, and participants. Moderators must remain within the resulting range.\n\nGuideline & Examples:\n• {{xpBand1}} XP: Environmental report or small specific assistance (low / simple)\n• {{xpBand2}} XP: Collecting a bag of litter, shopping help, or 1h tutoring (medium / simple)\n• {{xpBand3}} XP: Coordinated workshop or aid sorting (medium–high / coordinated)\n• {{xpBand4}} XP: Repair afternoon or smaller collection drive (high / complex)\n• {{xpBand5}} XP: Larger organized cleanup with team and disposal (exceptional / coordinated)\n• {{xpBand6}} XP: Multi-week mentorship or lasting support network (exceptional / complex)\n\nDonations reward personal effort, never monetary or goods value."
          ],
          [
            "What do global and category XP do?",
            "Verified XP increase your character level and rank. Category XP additionally increase your matching category level. Partners may gate offers by:\n• Rank or character level\n• Total XP or category XP\n• Specific verified system good deeds\n\nOrdinary partner redemption does not spend or consume XP."
          ],
          [
            "How do I earn and use category titles and badges?",
            "Each of the ten categories grants a title and badge at levels 2, 5, 10, 30, 50, 70 and 100. These require 200, 1,250, 5,000, 45,000, 125,000, 245,000 and 500,000 category XP. Choose one currently unlocked title for your profile, or display none. When a verified deed crosses a milestone, the confirmation popup shows its badge and title. Titles and badges are cosmetic and do not grant professional authority. A reversed XP award may lock a milestone again."
          ],
          [
            "What are cooldowns and parallel submissions?",
            "Individual actions and active group registrations share your slots. Open actions and active cooldowns each occupy a slot. Withdrawal or cancellation releases the slot immediately.\n\nFor individual actions, the cooldown starts when XP is awarded. For group actions, it runs from registration and does not restart when XP is awarded. “My slots” shows your current occupancy and remaining cooldowns."
          ],
          [
            "How does the XP boost work?",
            "Alchemists can activate a free experience elixir before one individual submission per calendar week:\n• +25% global and category XP on approval\n• Submission consumes the charge (even if rejected or withdrawn)\n• The weekly reset occurs Mondays at 00:00 UTC"
          ],
          [
            "Can I withdraw a good deed?",
            "Yes. In your submissions, you can withdraw your own good deed while it is under review:\n• Pending review assignments end immediately.\n• No reward or karma penalty is applied.\n• Approved or finally rejected actions cannot be withdrawn.\n• Withdrawing a group submission also cancels the entire group action."
          ]
        ]
      ],
      [
        "Tribunal & Appeals",
        [
          [
            "Who may moderate?",
            "Adventurers may apply from Rank {{tribunalRank}} and {{tribunalMinimum}} karma to become tribunal moderators. After admin approval, they can review cases. The following are excluded:\n• Own submissions or good deeds with own participation\n• Submissions from members of your own guild\n• New review rounds following an appeal decided by yourself"
          ],
          [
            "Are there anti-cheat measures in moderation?",
            "Yes. To prevent fraud and mutual approvals, automated anti-cheat rules are enforced:\n• Self-review ban & guild member restriction\n• Automatic cooldowns for repeated reviewer-user pairings\n• Mandatory review interleaving of other users\n\nAs a result, some submissions may only appear in the queue after a delay or after reviewing other good deeds."
          ],
          [
            "How many moderators review?",
            "The first assigned review fixes time and effort, planning and coordination, and base XP. The required number of reviews depends on XP thresholds:\n• Single review: For smaller good deeds\n• Multiple reviews: For medium to large good deeds (quorum decides by majority)\n• Admin review: For very high XP values, at least one system admin must review"
          ],
          [
            "Is one rejection enough?",
            "Only when the fixed XP require exactly one review. With multiple reviews, the quorum decides by majority. A 1–1 result automatically adds an independent third tie-break review. Submitters see the ongoing status and final outcome, not internal votes."
          ],
          [
            "How do appeals work?",
            "After a final rejection, you may file a reasoned appeal within the configured period:\n• A system admin decides whether to open a new independent review round.\n• The deciding admin cannot review that round.\n• The original evidence must still exist."
          ],
          [
            "How is an appeal different from the blacksmith's second review chance?",
            "An appeal challenges the rejection. You must explain why and file it within the configured period. A system admin decides whether to open a new review round; accepting the appeal does not approve the good deed.\n\nWith the “Second review chance” class ability, a blacksmith can revise one of their own rejected individual actions once and submit it directly for another review. You must change the description or upload new evidence, and have an available submission slot. This ability is not tied to the appeal deadline. You cannot use it for the same action while an appeal is pending."
          ]
        ]
      ],
      [
        "Evidence & Privacy",
        [
          [
            "Which short videos can I submit as evidence?",
            "You can submit short videos (MP4, max 10 seconds, 10 MB) in three categories:\n• Activity: Shows your contribution in progress\n• Before: Shows the initial state before start\n• After: Shows the result from the same perspective"
          ],
          [
            "Are before-and-after videos reviewed faster?",
            "Two clear “Before” and “After” videos make review easier and may speed up verification. However, automatic approval is not guaranteed. Make sure to avoid filming other people's faces or private data."
          ],
          [
            "How is evidence protected?",
            "Evidence is securely protected:\n• Encrypted storage outside the public web directory\n• Verification of file size, type, signature, and hashes\n• Recording of upload timestamp and accepted privacy policy version\n• Audit logging for every read access"
          ],
          [
            "Who may view evidence?",
            "Evidence is visible exclusively to:\n• You as the submitter\n• The currently assigned tribunal moderator\n• Authorized system admins"
          ],
          [
            "How long is evidence retained?",
            "The system sets an expiry after the final decision. A background service then automatically removes the file and database record."
          ],
          [
            "What are my data rights?",
            "In your profile you can:\n• Download a machine-readable copy of your data\n• Anonymize your account (contact data and evidence are removed, login disabled)"
          ]
        ]
      ],
      [
        "Guilds & Groups",
        [
          [
            "When can I found my own guild?",
            "The World Guild is your first stop to learn Goodvale and gain experience through approved good deeds. Founding a guild requires at least rank {{guildRank}}, {{guildActions}} approved good deeds of your own, and {{guildKarma}} karma. You must not already belong to a guild. After dissolving your guild or transferring its leadership, you wait {{guildCooldown}} days before founding another. Superadmins can change these requirements; the current values appear on the guild creation page."
          ],
          [
            "How does renown work?",
            "Shared progress and unlocked benefits are reflected in your guild’s renown and appearance. Gildex can be spent on internal guild features."
          ],
          [
            "How do group good deeds work?",
            "A guild admin announces a voluntary, non-commercial action on a separate form page. Invitations do not sign anyone up automatically. Everyone signs up individually, including the organizer if they want XP. From the scheduled start, each person confirms their own actual participation. At least two confirmations are required. The organizer submits shared evidence and the XP allocation. Rewards are credited only after final tribunal approval. Cancelling removes the action's invitation notifications; registered members receive a cancellation notification. Guild admins can open the detailed guide through the info icon next to group actions."
          ],
          [
            "Why do group actions have separate XP bands?",
            "Several adventurers share one pool. Group bands can be configured independently of individual bands. All values apply before bonuses and allocation:\n\nBand · Individual action / Group pool\n1 · {{xpBand1}} / {{groupBand1}} XP\n2 · {{xpBand2}} / {{groupBand2}} XP\n3 · {{xpBand3}} / {{groupBand3}} XP\n4 · {{xpBand4}} / {{groupBand4}} XP\n5 · {{xpBand5}} / {{groupBand5}} XP\n6 · {{xpBand6}} / {{groupBand6}} XP\n7 · Groups only: {{groupBand7}} XP\n8 · Groups only: {{groupBand8}} XP\n\nThe pool does not automatically grow with participant count. Equal shares divide the configured group pool evenly; larger groups receive smaller shares per person.\n\nTime and effort plus planning and coordination determine the band. Groups also have “Extensive team effort” and “Multi-stage organization”. Both highest levels together give band 8. The tribunal assesses documented contributions and actual organizational work."
          ],
          [
            "How does the organizer allocate group XP?",
            "Exactly 100% is allocated in whole percentages, exclusively to confirmed participants. Each person may receive 0–50%, including the organizer. At least two people need a positive share. Example for five people: 40 / 25 / 15 / 10 / 10%.\n\nThe tribunal must explicitly approve the allocation. Shares are locked during review. If the action is returned, the organizer can revise and resubmit them, starting a new review round. A 0% share gives neither XP nor karma and contributes no group buff. The 50% cap applies before personal bonuses."
          ],
          [
            "What happens if someone does not turn up?",
            "Anyone who withdraws or does not confirm participation receives no reward and contributes no group buff. People who remain registered only are withdrawn at submission. Wait for everyone who actually participated to confirm.\n\nThere is currently no dedicated report button or automatic penalty for false participation confirmations. Before submission, the organizer can assign 0% and explain the situation in the description. After submission, the tribunal must return the action before changes can be made."
          ],
          [
            "How do buffs affect the group pool?",
            "The pool is calculated first: base XP × event factor × (1 + guild upgrade + group buff), rounded down. Saved percentage shares are then allocated, followed by personal bonuses. Global XP and category XP are calculated separately.\n\n• Only confirmed people with positive shares contribute group buffs.\n• The strongest Bard bonus applies once, normally 10%.\n• Group Mentor gives 5 / 10 / 15% by rank; contributions from multiple people add together. Class group bonuses and group talents combined are capped at 50%.\n• Only the highest unlocked guild upgrade applies (1–5%). The personal 5% guild membership bonus applies after allocation.\n• The experience elixir is for individual actions only; temporary personal buffs do not apply here.\n\nExample: 2,000 base XP, no event bonus, a 5% guild upgrade, a 10% Bard bonus and 10% Group Mentor produce a pool of 2,500 XP. Shares of 40 / 25 / 15 / 10 / 10% give 1,000 / 625 / 375 / 250 / 250 XP before personal bonuses. Remainder XP is preserved during allocation; personal XP is rounded down afterwards.\n\nClass and talent effects are saved at submission and captured again on a revised submission. The event factor and guild upgrade are fixed in the first tribunal review."
          ],
          [
            "May partners assign work through guilds?",
            "No. Guild good deeds must not replace a paid position, work shift, or normal commercial service. Guild admins confirm the non-commercial and voluntary nature before announcing."
          ],
          [
            "What are Gildex?",
            "Gildex are internal guild progression points with no monetary value:\n• On verified good deeds, the guild receives a percentage of base XP as Gildex (your XP are not reduced).\n• Gildex cannot be purchased, cashed out, or transferred.\n• Guild admins can spend Gildex exclusively on internal guild decorations and convenience features."
          ],
          [
            "What is the difference between guild renown and Gildex?",
            "• Guild Renown: Reflects past overall progress from rewarded good deeds and determines how your guild hall looks.\n• Gildex: Available balance for internal unlocks (spending Gildex does not reduce guild renown)."
          ]
        ]
      ],
      [
        "Partners & QR Pass",
        [
          [
            "How do I redeem an offer?",
            "Open your QR pass:\n• A partner scans the code and sees authorized profile data.\n• Signature, expiry, user binding, and requirements are checked server-side."
          ],
          [
            "Can a screenshot be reused?",
            "No. The pass is signed, expires quickly, and contains a random one-time ID that is permanently invalidated upon first use."
          ],
          [
            "Are XP money or currency?",
            "No. XP are game progress with no monetary value. Progress unlocks partner offers; partners carry responsibility for fulfillment."
          ],
          [
            "Do classes change partner discounts?",
            "No. The regular discount of the partner offer always applies."
          ]
        ]
      ],
      [
        "Classes, Perks & Karma",
        [
          [
            "Can I change my class after registration?",
            "Yes. In your profile, select and confirm another available class under “Change class”. You can do this once within the first seven days (168 hours) after registration. Your profile shows the exact deadline. After using your change or after the deadline, you cannot change your class again."
          ],
          [
            "What happens to my XP and bonuses when I change class?",
            "Previously awarded global and category XP is not recalculated. Your levels and rank also stay unchanged. Ongoing heroic actions keep their saved bonuses; new heroic actions use your new class bonuses. Changing class does not reset abilities you have already used."
          ],
          [
            "Which class perks exist?",
            "All classes receive +20% global and category XP for approved actions in their category. Specific abilities are:\n• Scout: 10% shorter cooldown\n• Tank: +1 slot for parallel submissions\n• Paladin: +1 karma for every approved action\n• Blacksmith: Repair one rejected individual action once\n• Bard: +10% group XP (non-stacking)\n• Merchant: Skip cooldown once a week\n• Alchemist: +25% XP on one individual submission per week\n• Mage: +10% category XP outside own category\n• Druid: +20% Gildex from individual actions\n• Cleric: +1 recovery karma while negative (up to max 0)"
          ],
          [
            "Do talents differ by class?",
            "No. All classes share the same talent paths and talents. Your class determines your class ability; you can unlock talents regardless of your class."
          ],
          [
            "What is karma?",
            "Karma is your personal trust score ({{karmaMinimum}} to {{karmaMaximum}}):\n• Starts at 0 and is not a currency.\n• Direct karma deductions do not change XP.\n• Higher karma unlocks trust tiers."
          ],
          [
            "How do I earn karma?",
            "Verified good deeds reward karma:\n• At least +1 karma per approved action (or configured reward)\n• Karma talents additionally increase yield\n• Recovery bonuses apply while negative (up to 0)\n• Rejections or withdrawals do not reduce karma\n• For group actions, only confirmed people with positive XP shares receive karma; a 0% share gives no karma."
          ],
          [
            "Who can deduct my karma?",
            "In case of misconduct or fraud:\n• Guild admins may deduct karma from members of their guild (1–100 points with reason).\n• Superadmins may act across guilds.\n• You receive a notification with reason and admin identity."
          ],
          [
            "Does negative karma suspend my account?",
            "From {{partner}} to {{partnerEnd}} karma, partner benefits are blocked. From {{xp}} to {{xpEnd}}, {{percent}}% of total XP is deducted daily. At {{tribunalLoss}}, an existing Tribunal role is revoked. From {{suspension}} to {{karmaMinimum}}, the account is suspended for {{months}} calendar month(s). Verified good deeds rebuild karma."
          ],
          [
            "Where can admins manage karma?",
            "Admins can find “Manage karma” in the profile to search for users and issue karma deductions with a mandatory explanation."
          ]
        ]
      ]
    ]
  },
  "admin_directory": {
    "delete_guild": "Delete guild",
    "delete_guild_confirm": "Permanently delete guild “{{name}}”? All members leave the guild, but their user accounts remain. Guild data and unlocks will be deleted and ongoing group actions cancelled. This cannot be undone.",
    "guilds": "All guilds",
    "karma": "Karma",
    "karma_suspended": "Temporarily suspended by karma",
    "karma_suspended_until": "Karma suspension until {{date}}",
    "manual_suspension_separate": "Manual account suspension is managed separately and is independent of the karma suspension.",
    "search_guilds": "Search guild name or description …",
    "treasury": "Treasury",
    "total_xp": "Total XP",
    "manage_guild": "Manage Guild",
    "view_public": "Public Guild Page",
    "stats_summary": "Guild Key Metrics",
    "rate": "Gildex Rate",
    "tab_karma": "Karma Moderation",
    "level_and_rank": "Level & Rank",
    "hero_class": "Hero Class",
    "karma_score": "Karma Score",
    "guild_hall": "Guild Hall ({{name}})",
    "error_loading_guild_details": "Failed to load guild details",
    "rate_label": "Rate: {{rate}}% Base XP",
    "unlocked_upgrades": "Unlocked guild upgrades",
    "actions_and_gildex": "Good Deeds & Gildex Generation",
    "gildex_generated": "+{{amount}} Gildex generated",
    "total_gildex_yield": "+{{amount}} Gildex total yield",
    "guild_members_count": "Guild Members ({{count}})",
    "guild_leader": "Guild Leader",
    "xp_collected": "{{amount}} XP collected",
    "no_members_in_guild": "No members in this guild.",
    "guild_announcements_count": "Guild Notices & Announcements ({{count}})",
    "class": "Class",
    "no_guild": "No guild"
  },
  "classesAndRanks": {
    "title": "Classes",
    "subtitle": "Explore ten hero classes and their abilities.",
    "classes": "Hero classes",
    "classesIntro": "Choose a class that suits your interests. You earn more XP in its category and gain a special ability.",
    "perk": "Class perk",
    "noPerk": "Your class configuration shows the specific class perk.",
    "loadError": "The class configuration could not be loaded. Default values are shown."
  },
  "ranksGuide": {
    "title": "Ranks",
    "subtitle": "Your rank grows with XP earned from approved good deeds.",
    "ranks": "Rank progression",
    "ranksIntro": "Your rank is based on all XP you have earned from approved good deeds.",
    "xp": "total XP",
    "noteTitle": "Level and rank explained",
    "note": "Your level and rank grow with total XP from approved good deeds. You also earn separate XP in each category.",
    "whyRanksTitle": "Why do ranks matter?",
    "whyRanksIntro": "Your rank shows your progress and matters for some opportunities in Goodvale:",
    "whyRanks": [
      {
        "title": "Found your own guild",
        "text": "You need the required rank and must meet the other conditions."
      },
      {
        "title": "Apply to the Tribunal",
        "text": "Once you reach the required rank, you can apply to review good deeds. Approval is required before you receive the role."
      },
      {
        "title": "Use partner offers",
        "text": "Some offers may require a minimum rank. You can find the requirements on each offer."
      }
    ]
  },
  "landing": {
    "eyebrow": "Level up the world",
    "title": "The adventure begins in real life.",
    "guildFeature": {
      "title": "A guild turns individual deeds into a shared adventure.",
      "intro": "A guild connects you with people who share ideas, organize help, and celebrate progress. Join an existing community or start your own. Your guild home shows what you have achieved together.",
      "points": [
        {
          "title": "Act together",
          "body": "Plan voluntary group deeds, sign up yourself, and confirm your participation. After Tribunal approval, group experience is divided among confirmed participants. Class and talent bonuses can strengthen the shared result."
        },
        {
          "title": "Build the treasury",
          "body": "Approved good deeds add Gildex to the assigned guild without reducing your own XP. The guild can unlock chat, group deeds, guild home designs, and more with these shared resources."
        },
        {
          "title": "Share the benefits",
          "body": "Guild membership already grants a general 5% XP bonus. A guild can unlock additional experience boost tiers with Gildex. The highest purchased tier adds another 1 to 5 percentage points."
        }
      ],
      "closing": "Guild renown, shared deeds, and unlocked rooms show how your community grows. Guild leaders spend earned Gildex on benefits for everyone.",
      "action": "Become an adventurer"
    },
    "partnerFeature": {
      "points": [
        {
          "title": "Be visible locally",
          "body": "Use a partner profile to introduce your business, location, and offers. Adventurers discover relevant benefits as they make progress through real good deeds."
        },
        {
          "title": "Shape your offers",
          "body": "Create discounts, extras, vouchers, or services. Set conditions such as rank, XP, category, karma, and approved event deeds, as well as availability periods and limits."
        },
        {
          "title": "Make redemption easy",
          "body": "On site, verify a short-lived QR pass. Eligible adventurers redeem digital offers themselves. Manage offers and view redemptions in the partner area."
        }
      ],
      "closing": "Partner offers reward effort; they do not purchase XP or ranks. Partner accounts are reviewed after registration before offers can be published."
    },
    "roles_kicker": "The Goodvale ecosystem",
    "roles_title": "4 parts. One shared goal.",
    "karma_title": "Karma at a glance",
    "karma_intro": "The karma scale shows when benefits are blocked, Tribunal rights are revoked, and other consequences apply. Select a threshold for details.",
    "karma_more": "Karma in detail",
    "subtitle": "Whether you help someone in daily life or care for your community, every good deed counts. From small gestures to heroic deeds with your guild, you can achieve a lot. Earn experience and discover rewards from local partners.",
    "join": "Join a guild",
    "classesSubtitle": "Ten classes, one shared goal: make the world a little better through acts both big and small.",
    "cards": [
      [
        "Adventurers",
        "Do good in everyday life—small gestures can make a big difference. Earn experience, rank up, and unlock rewards."
      ],
      [
        "Tribunal",
        "As an experienced guardian, review and verify submitted good deeds according to strict quality and honor standards."
      ],
      [
        "Guilds",
        "Unite with like-minded allies, tackle collective challenges, and build up your guild treasury."
      ],
      [
        "Partners",
        "Support committed people in your local region and reward verified good deeds with real benefits."
      ]
    ],
    "hero_prefix": "Small acts. Big",
    "hero_emphasis": "impact.",
    "categories_examples": "Good deed and XP examples"
  },
  "partnerSettings": {
    "subtitle": "Manage your partner profile and your exclusive offers for adventurers."
  },
  "guild_treasury": {
    "confirm": "Unlock \"{{name}}\" for {{price}} Gildex?",
    "insufficient": "Not enough Gildex.",
    "loading": "Loading treasury...",
    "shop_title": "Guild Shop & Catalog",
    "shop_intro": "Unlock exclusive hall themes, the common room, and upgrades for your guild.",
    "title": "Gildex Ledger & History",
    "rate": "Current conversion rate: {{rate}}% of base XP",
    "no_money": "Gildex cannot be purchased.",
    "admin": "Only guild admins can spend Gildex.",
    "base": "Base: {{xp}} XP ({{rate}}%)"
  },
  "guildGildexTreasury": {
    "title": "Gildex treasury",
    "subtitle": "The guild's shared reserves. Gildex is proportionally added to the treasury through approved good deeds."
  },
  "adminHeroicActions": {
    "reviewUnavailable": {
      "assignment": "You currently have no eligible review assignment. Assignment, guild relationships and review cooldowns apply."
    },
    "tableHero": "Hero",
    "keepWarning": "Awarded XP, karma and guild rewards are retained.",
    "reverseWarning": "Recorded XP, category XP, karma and guild rewards are reversed, including group participants. Previously spent Gildex can result in a negative guild balance.",
    "reviewCategoryHint": "Check the selected category and correct it if needed. The first review fixes it for this review round; category XP and bonuses use this category.",
    "badge": "Tribunal & Moderation",
    "title": "Tribunal",
    "subtitle": "Review pending good deeds and evaluate the effort and evidence of adventurers.",
    "antiCheatNotice": "Notice: Due to anti-cheat measures (cooldowns, guild filters, and review interleaving), some submissions will only appear in your queue after reviewing other good deeds or after a waiting period.",
    "xpLabel": "XP and base values",
    "searchPlaceholder": "Search good deed or adventurer…",
    "allRanks": "All ranks",
    "allBands": "All XP bands",
    "rank": "Rank",
    "xpBand": "XP Band",
    "applications": "Applications for the Tribunal",
    "organizerOkay": "Guild organizer policy confirmed",
    "organizerMissing": "Guild organizer policy pending",
    "heroEstimate": "Hero estimate:",
    "assessHint": "Set binding time and effort, planning and coordination, and XP rewards.",
    "baseGroup": "Base XP (entire group)",
    "base": "Base XP",
    "categoryGroup": "Category XP (entire group)",
    "guidanceAdmin": "Admin review required (exceptional or high XP)."
  },
  "adminAppeals": {
    "detailIntro": "Review the reason and decide whether to start a new tribunal round."
  },
  "quick_heroic_action": {
    "experience_elixir": "Experience Elixir: +25% XP when approved."
  },
  "heroicActions": {
    "slots_full_redirect": "All slots are occupied by open quests or cooldowns. Visit My slots to see when a slot will become available.",
    "breakdown": {
      "total": "Total XP",
      "category": "Category XP",
      "guild": "Guild bonus",
      "partyTalent": "Group talent",
      "classBonus": "Class bonus",
      "groupFormula": "Calculation: ⌊{{base}} × {{event}} × (1 + {{guild}}% guild + {{party}}% party)⌋",
      "groupTotal": "Group XP after event, guild and party bonuses: {{total}}",
      "share": "Share before personal bonuses: {{xp}} XP ({{percent}}% approved by the tribunal)",
      "legacyShare": "Share before personal bonuses: {{xp}} XP among {{count}} participants",
      "credited": "Personally credited: {{xp}} XP",
      "missingFactors": "Event/guild effects and rounding that cannot be reconstructed individually: {{xp}} XP",
      "rounding": "The event factor applies first. Group XP are allocated by share with remainders distributed; personal bonuses are then applied and rounded down.",
      "legacyFactors": "Not all factors were saved for this older submission. The final credit comes from the XP ledger."
    },
    "categoryXp": "category XP",
    "eine_reparatur_pro_h": "One repair per good deed. Revise the description or submit a new evidence. The tribunal will review again.",
    "klassenf_higkeit": "Class ability",
    "filterXp": "XP Band",
    "allXpBands": "All XP Tiers",
    "sortXpDesc": "XP (Highest first)",
    "sortXpAsc": "XP (Lowest first)",
    "xpFor": "XP for",
    "closeXpBreakdown": "Close XP breakdown",
    "showXpBreakdown": "Show XP breakdown",
    "xpBreakdown": "XP breakdown",
    "baseXp": "Base XP set by the tribunal",
    "awardedXp": "Awarded XP"
  },
  "heroicActionXpGuide": {
    "baseXp": "Base XP",
    "title": "XP guidance and examples",
    "intro": "Every good deed counts, including small everyday acts of kindness. Estimate how much time and effort your deed required and how much planning and coordination was needed. Together, these estimates determine a binding XP band. The Tribunal reviews your assessment and awards base XP within that band. Class and boost bonuses are applied afterwards.",
    "subtitle": "Guidance on time and effort, planning and coordination, and XP bands",
    "estimatedXp": "Estimated XP",
    "bandOption": "Band {{band}} ({{min}}–{{max}} XP)",
    "groupBaseXp": "Base XP in the group pool",
    "groupIntro": "Group actions have eight separate XP bands with larger shared pools. The tribunal assesses documented joint effort. Participant count alone does not increase the pool. Bonuses apply to the pool before it is divided using saved percentage shares. Individual actions use their own six bands.",
    "mixedBandOption": "Band {{band}} · Solo {{soloMin}}–{{soloMax}} / Group {{min}}–{{max}} XP",
    "groupBandOption": "Group band {{band}} ({{min}}–{{max}} XP)"
  },
  "guild_administration": {
    "profile_title": "Guild Details & Location",
    "profile_intro": "Update your guild's official details, mission, and guildhall location on the world map.",
    "official_name": "Official guild name",
    "description_label": "Guild motto & philosophy / description",
    "description_placeholder": "Describe your guild's ideals, good deed focus, and history...",
    "location_label": "Guild location on the world map",
    "name_required": "Please enter an official guild name.",
    "profile_saved": "Guild details and location saved.",
    "emblem_title": "Guild Emblem Forge",
    "emblem_settings_title": "Manage guild emblem",
    "emblem_intro": "Customize your guild's heraldic emblem. The banner represents your guild throughout the kingdom and on profile cards.",
    "emblem_alt": "Guild emblem",
    "emblem_admin_only": "Only guild admins can edit and save the emblem.",
    "emblem_saved": "Guild emblem saved.",
    "forge_upgrade_intro": "Unlock the advanced emblem forge in the guild shop for more motifs and design options.",
    "theme_intro": "Explore your guildhall styles. Guild admins can select an unlocked design for their view.",
    "unlock_in_shop": "→ Unlock in shop ({{price}} Gildex)",
    "applications_intro": "Review applications from adventurers who want to join your guild.",
    "bans_title": "Guild Bans & Banned Adventurers ({{count}})",
    "bans_intro": "Banned players can no longer join this guild. You can lift bans here at any time.",
    "no_bans": "No active guild bans.",
    "ban_success": "\"{{name}}\" was removed and banned from the guild."
  },
  "guildDetail": {
    "active_adventurers": "{{count}} active adventurers",
    "berpr_fe_neue_beitr": "Review new join requests from adventurers.",
    "passe_das_wappen_dei": "Customize your guild emblem. The emblem represents you throughout the kingdom.",
    "gebannte_spieler_k_n": "Banned players can no longer join this guild. You can lift bans here at any time.",
    "abenteurer_aus_gilde": "Ban adventurer from guild",
    "gildenhaus_nicht_gef": "Guild hall not found",
    "der_abenteurer_wird": "The adventurer will be removed from the guild immediately and their future join requests will be permanently blocked.",
    "zur_ck_zur_gilden_be": "Back to guild overview",
    "wird_auf_visitenkart": "Displayed on business cards and in the tavern."
  },
  "adminClassCategoryManager": {
    "keine_klassen_vorhan": "No classes available.",
    "erkl_re_genau_wie_di_placeholder": "Explain exactly how this perk works and which good deeds, XP, or partner benefits it affects..."
  },
  "gameMechanics": {
    "faire_xp_teilung": "Fair XP sharing"
  },
  "guildMembersAdmin": {
    "der_abenteurer_wird": "The adventurer will be removed from the guild immediately and their future join requests will be permanently blocked.",
    "es_sind_derzeit_kein": "There are currently no adventurers blocked for this guild.",
    "gesperrte_abenteurer": "Banned adventurers",
    "abenteurer_aus_gilde": "Ban adventurer from guild",
    "lade_gesperrte_abent": "Loading banned adventurers...",
    "neue_beitrittsanfrag": "New join requests from adventurers will appear here for review."
  },
  "systemEvents": {
    "karma": "Karma",
    "xp_multiplier": "+{{percent}}% XP (×{{multiplier}})",
    "base_xp": "★ {{count}} XP",
    "cat_xp": "🎖️ {{count}} Cat-XP",
    "karma_reward": "👑 {{count}} Karma",
    "base_xp_label": "Base XP",
    "cat_xp_label": "Category XP",
    "bonus_xp": "+{{percent}}% Event XP."
  },
  "worldMapView": {
    "gilde_betreten": "Enter guild",
    "gildenruhm": "Guild renown",
    "w_hle_eine_gilde_ode": "Select a guild or partner on the map to see more details.",
    "guilds": "Guilds",
    "guild_type": "Guild"
  },
  "partnerDetail": {
    "adventurer_missing": "Adventurer not found.",
    "adventurer_required": "Only approved adventurers can redeem digital offers.",
    "how_to_redeem_desc": "Present your official Guild QR Pass at the checkout or service desk. The partner scans your code and applies the perk instantly!"
  },
  "heroicOverview": {
    "karma": "Karma",
    "total_xp": "Total XP"
  },
  "guild_overview": {
    "renown_and_stage": "Guild Renown & Upgrade Stage",
    "renown_description": "Permanently accumulated base XP from your guild's credited good deeds.",
    "gildex_earned": "Gildex Earned",
    "balance_suffix": "Gildex balance: {{balance}}.",
    "guild_members": "Guild Members",
    "ep_boost_title": "Magical XP Boost",
    "ep_boost_active": "+{{percent}}% XP bonus active",
    "ep_boost_inactive": "No XP bonus active",
    "ep_boost_status_active": "XP bonus active",
    "ep_boost_hint": "Unlock level 1 to earn more XP for good deeds as a guild.",
    "ep_boost_desc": "The magical fountain amplifies experience points earned by all guild members from good deeds by {{percent}}%.",
    "ep_boost_upgrade": "Upgrade in Guild Shop →",
    "ep_boost_activate": "Unlock in Guild Shop →",
    "ep_boost_max": "Maximum XP boost level reached (+5%)"
  },
  "guild_hall_stage": {
    "aria_label": "Guild Hall",
    "bg_alt": "Guild Hall Background",
    "banner_aria": "Guild Crest & Banner",
    "banner_sprite_alt": "Guild Banner",
    "default_guild_name": "Guild Crest",
    "profile_wall_aria": "Profile Wall: Guild Members",
    "trophy_shelf_locked": "Trophy Room (Guild Shop)",
    "chest_aria": "Guild Chest (Treasury)",
    "chest_title": "Treasury (Gildex & Vault)",
    "shop_stall_aria": "Guild Merchant Stall",
    "shop_stall_sprite_alt": "Merchant Stall",
    "shop_stall_title": "Guild Catalog & Unlocks",
    "stammtisch_aria": "Guild Stammtisch (Chat)",
    "stammtisch_unlocked": "Guild Stammtisch",
    "stammtisch_locked": "Guild Stammtisch (Guild Shop)",
    "group_table_unlocked": "Guild Conference Table (Group Actions)",
    "group_table_locked": "Group Action Table (Guild Shop)",
    "admin_desk_aria": "Guild Leader Desk (Administration)",
    "admin_desk_unlocked": "Admin Desk (Guild Leadership)",
    "admin_desk_locked": "Guild Leader Desk (Guild Shop)",
    "anvil_aria": "Crest Anvil (Guild Design)",
    "anvil_locked": "Crest Anvil (Guild Shop)",
    "fountain_aria": "XP Fountain",
    "fountain_sprite_alt": "XP Fountain",
    "fountain_unlocked": "XP Fountain (+{{percent}}% XP Boost)",
    "fountain_locked": "XP Fountain (Guild Shop)"
  },
  "system_admin": {
    "adventurer_view": "Adventurer View"
  },
  "partner_portal": {
    "brand_title": "Portal"
  },
  "partner_redemptions": {
    "subtitle": "Overview of all redemptions of your offers by adventurers (On-Site and Remote/Digital).",
    "stat_adventurers": "Adventurers Reached",
    "search_placeholder": "Search adventurer, offer, guild, or code …",
    "no_redemptions_desc": "Once adventurers redeem your offers on-site via QR pass or digitally, they will appear here."
  },
  "partner_profile": {
    "bio_placeholder": "Describe your company, offerings, or special perks for adventurers on the world map …"
  },
  "audit_ui": {
    "room": {
      "news": {
        "description": "News from your guild"
      },
      "roster": {
        "description": "The people behind your guild"
      },
      "trophies": {
        "title": "Trophy room"
      },
      "stats": {
        "description": "Explore your guild's renown and progress"
      },
      "settings": {
        "description": "Manage members and guild settings"
      },
      "treasury": {
        "title": "Treasury",
        "description": "Your shared guild treasury"
      },
      "forge": {
        "title": "Emblem forge",
        "description": "Your guild emblem and its design"
      }
    },
    "all_guilds": "All guilds",
    "view_hall_image": "View the full guild hall image",
    "emblem": "Guild emblem",
    "welcome": "Welcome to your guild home",
    "your_guild": "Your guild",
    "home": "Guild home",
    "updates": "Guild updates",
    "news_hint": "Your guild news will appear here.",
    "treasure": "Shared guild treasury",
    "rooms": "Your guild rooms",
    "unlock_shop": "Unlock in the guild shop",
    "shop": "The guild shop",
    "shop_heading": "A home that grows with you.",
    "tools": "Guild tools",
    "boost_discover": "Discover XP bonus",
    "boost": "XP bonus +{{percent}}%",
    "theme_alt": "{{theme}} and its adjoining guild rooms",
    "themes": {
      "default": "Standard keep",
      "forest": "Forest hall",
      "celestial": "Celestial hall"
    },
    "karma_designation": "Karma designation",
    "guild": "Guild",
    "no_guild": "No guild yet"
  },
  "categories_guide": {
    "intro": "Every good deed belongs to one area. Alongside your total XP, you earn XP in that category. Choose the category that best matches what you actually did.",
    "examples_link": "See examples and XP"
  },
  "category_showcase": {
    "xp_caption": "Good deeds. Dedicated category XP."
  },
  "landing_classes": {
    "heading_title": "Choose your path",
    "heading_subtitle": "Ten classes, one shared goal: making real good deeds visible.",
    "picker_label": "Choose a class to preview",
    "loading_perks": "Loading class perks …",
    "no_perks": "No perks are currently configured for this class.",
    "selected_class": "Selected Class",
    "explore_class": "Explore class",
    "no_classes": "No classes are currently available.",
    "choose_class_title": "Choose your class",
    "choose_class_hint": "Click an emblem or the button to choose your class."
  },
  "good_deed_examples": {
    "intro": "These examples show roughly how effort relates to XP. Reviewers assess what you actually did and the evidence; the numbers are guidance.",
    "table_label": "XP examples",
    "xp_title": "How are XP determined?",
    "xp_intro": "Time, effort, responsibility, planning, coordination, and the people involved all matter. For donations, your own work counts, not the monetary value. XP are awarded only after final approval."
  },
  "guildHeroicActions": {
    "statuses": {
      "PendingReview": "At tribunal"
    },
    "chat": {
      "submitted": "[HEROIC ACTION] {{title}} was submitted to the tribunal with {{count}} confirmed participants.",
      "evidenceUploaded": "[HEROIC ACTION] {{title}}: The encrypted evidence was uploaded and the action was sent to the tribunal."
    },
    "adminOnly": "Only guild admins can announce group good deeds.",
    "intro": "Guild members coordinate together. The organizer allocates verified XP; the tribunal reviews the allocation.",
    "locked": "Group good deeds are locked. A guild admin can unlock them in the Gildex shop.",
    "split": "base XP, then allocated by the organizer",
    "allocationTitle": "XP allocation",
    "submit": "Submit to tribunal",
    "resubmit": "Resubmit to tribunal",
    "allocationFor": "XP share for {{name}}",
    "allocationBonuses": "These shares apply before personal bonuses. Whole XP are rounded with remainder allocation, so amounts may differ by less than 1 XP.",
    "allocationReviewTitle": "Organizer XP allocation",
    "allocationApprove": "Have you reviewed and approved the organizer’s XP allocation?",
    "guideLink": "Explain group action workflow and XP"
  },
  "groupActionGuide": {
    "eyebrow": "Guide for guild admins",
    "intro": "Anna organizes a litter cleanup with Ben, Clara, David and Eva. Follow the action from invitations to rewards, including withdrawals, tribunal decisions and XP bonuses.",
    "navigation": [
      "Workflow",
      "No-shows",
      "XP & buffs",
      "Decisions & completion"
    ],
    "steps": [
      {
        "title": "Announce the action",
        "text": "The guild needs the Group Actions unlock. Open the separate form page with “Announce good deed”. Set the title, description, category, difficulty, complexity and date; a signup deadline and participant limit are optional. Confirm voluntary participation, a non-commercial purpose, safe organization and that the action does not replace paid work. Members are notified."
      },
      {
        "title": "Invite and sign up individually",
        "text": "Invitations do not register anyone automatically. All five sign up themselves, including Anna if she wants XP. Registration requires and occupies an available good-deed slot. Until submission, participants can withdraw and the guild admin can cancel the action. Cancelling removes the action's invitation notifications; registered members receive a cancellation notification."
      },
      {
        "title": "Participate and confirm yourself",
        "text": "From the scheduled start, each person confirms their own actual participation. There is no confirmation on someone else’s behalf or mutual confirmation. Wait for everyone who took part before submitting: at least two confirmations are required. People who remain only registered are withdrawn when the action is submitted."
      },
      {
        "title": "Allocate 100% in whole percentages",
        "text": "Anna could assign 40 / 25 / 15 / 10 / 10%. No person may receive more than 50%, including Anna. Only confirmed participants count. Zero is allowed, but at least two people need a positive share. Decimal percentages are not allowed. With more than 100 people, some must receive 0%. Participants do not separately approve the allocation."
      },
      {
        "title": "Upload shared evidence",
        "text": "Choose an image, PDF or MP4 and acknowledge the privacy notice. The submission is saved first, then the evidence is uploaded. If the upload fails, you can retry it. Only then does the action go to the tribunal. Shares are locked during review."
      },
      {
        "title": "The tribunal decides",
        "text": "The tribunal reviews the evidence and allocation. The first review sets category, difficulty, complexity, base XP and category XP. Each approval must explicitly accept the allocation. Reviewing your own action is prohibited; regular moderators cannot review their own guild’s actions either. Rewards are booked once the required reviews approve the action."
      }
    ],
    "absence": [
      {
        "title": "Eva withdraws or does not confirm",
        "text": "Eva receives no XP and contributes no group buff. If she remains registered only, submission automatically withdraws her. Anna allocates 100% among the remaining confirmed participants. Someone who participated but forgot to confirm is also excluded this way."
      },
      {
        "title": "Eva falsely confirms participation",
        "text": "There is currently no dedicated no-show report button, attendance verification or automatic penalty. Before submitting, Anna can assign 0% and explain the situation in the description. Eva remains technically confirmed, but receives neither XP nor karma and contributes no group buff. After submission, the tribunal must return the action before shares can change."
      },
      {
        "title": "What the percentage rule does not check",
        "text": "A positive share of 1% or more enables the person’s full applicable group buff. The system does not verify a minimum contribution. Actual contributions must be clear from the description, evidence and tribunal review."
      }
    ],
    "xpTitle": "How XP and buffs work",
    "xpIntro": "A shared XP pool is calculated first, then divided using the saved shares. Personal bonuses apply to each person’s share afterwards. Global XP and category XP are calculated separately.",
    "rules": [
      "Exactly 100% in total, using only whole percentages from 0 to 50 per confirmed person.",
      "At least two positive shares. For three people, the equal suggestion is 34 / 33 / 33%.",
      "The 50% cap applies before personal bonuses. It does not cap a person’s proportion of all final credited XP."
    ],
    "formula": "Group pool = floor(base XP × event factor × (1 + guild upgrade + group buff))",
    "example": "Example in group band 5: the tribunal awards 2,000 base XP and 2,000 category XP. No event bonus (factor 1), a 5% guild upgrade, 10% from Ben as a Bard and 10% from Clara’s rank 2 Group Mentor produce pools of 2,500 each. All five also have the personal 5% guild membership bonus. Anna is a Druid with another 20% in Environment & Nature. David is a Mage with another 10% category XP here. We assume no other talents.",
    "columns": [
      "Person",
      "Share",
      "Pool share",
      "Global XP",
      "Category XP"
    ],
    "rows": [
      [
        "Anna · Druid",
        "40%",
        "1000",
        "1250",
        "1250"
      ],
      [
        "Ben · Bard",
        "25%",
        "625",
        "656",
        "656"
      ],
      [
        "Clara",
        "15%",
        "375",
        "393",
        "393"
      ],
      [
        "David · Mage",
        "10%",
        "250",
        "262",
        "287"
      ],
      [
        "Eva",
        "10%",
        "250",
        "262",
        "262"
      ],
      [
        "Total",
        "100%",
        "2500",
        "2823",
        "2848"
      ]
    ],
    "rounding": "Remainder XP is distributed deterministically so no pool XP is lost. Whole-XP rounding may differ from the exact percentage by less than 1 XP per person. Personal XP is rounded down afterwards.",
    "buffs": [
      "XP events multiply base XP. Without an active event, the factor is 1.",
      "Guild upgrade: only the highest unlocked tier applies (1–5%). Guild membership also gives a separate personal 5%.",
      "Bard: a standard 10% group bonus. Multiple Bards do not stack this class bonus; only the strongest class group bonus applies.",
      "Group Mentor: 5 / 10 / 15% by rank. Contributions from multiple people add together. Class group bonuses and group talents combined are capped at 50%.",
      "Only confirmed people with positive XP shares contribute group buffs. A buff is not reduced in proportion to its owner’s share.",
      "Matching class bonuses normally add 20% global and category XP. Personal XP bonuses add together; category-only bonuses affect category XP only.",
      "The weekly experience elixir applies only to individual actions. Temporary personal buffs are not included in these group rewards."
    ],
    "buffTiming": "Class and talent effects are saved per person at submission and captured again on a revised submission. The event factor and guild upgrade are fixed in the first tribunal review. Later changes do not retroactively increase the current review round.",
    "outcomes": [
      {
        "title": "Returned for revision",
        "text": "Anna can revise the description and allocation and resubmit with evidence. A new review round begins; previous approvals do not apply. The tribunal does not edit the shares itself. While returned, the action does not occupy an open slot."
      },
      {
        "title": "Rejection and appeal",
        "text": "Rejection pays no rewards. The submitter or confirmed participants may file a reasoned appeal, by default once within 30 days and with the original evidence. An independent system admin decides. An accepted appeal starts a new tribunal round; it does not pay XP yet."
      },
      {
        "title": "Number of reviews",
        "text": "By default, up to 150 group XP requires one review, up to 500 requires two, and above 500 requires three. At 500 or more, an admin review must be included. A tied vote requires another review."
      },
      {
        "title": "Karma, Gildex and notifications",
        "text": "People with positive shares normally receive at least 1 karma, plus applicable personal bonuses. Tribunal-awarded honor is divided equally among positive-share recipients. A 0% share gives neither XP nor karma. The guild receives Gildex once from base XP, normally 10%: 200 Gildex in this example. All confirmed people are notified of the result, including those with 0%."
      },
      {
        "title": "Slot and cooldown",
        "text": "The group cooldown starts at registration, normally 24 hours, potentially reduced by effects. While the action remains open, the slot stays occupied even if this timer has elapsed. Reward payment does not restart the timer. Withdrawal, cancellation or rejection releases the open reservation."
      },
      {
        "title": "Leaving the guild during an action",
        "text": "Leaving or being removed ends active participation. A submitted action is cancelled if fewer than two confirmed people remain. If others remain, an allocation made invalid by the departure is not automatically redistributed; it must be resolved before approval, with a returned revision if necessary."
      }
    ],
    "defaults": "These numbers explain current defaults. Admins can configure review thresholds, cooldowns, Gildex rates and class effects. Older saved allocations remain intact for payment and recalculation; new or revised allocations use whole percentages.",
    "assessmentBands": "The two scales determine the band number. Extensive team effort with “Highly planned”, or “Very high” effort with multi-stage organization, gives group band 7 (4,000–6,000 base XP by default). Both new highest levels give group band 8 (6,000–10,000). Group bands 1–6 also have their own larger pools. All group values are configurable independently of individual actions.",
    "assessmentExample": "Example: several teams improve a community space over multiple workdays. Materials, permissions, work phases and handovers between organizations need documented coordination. Both new levels may fit; the tribunal decides based on actual contributions."
  },
  "systemCopy": {
    "16885658fbb9": " (Gildex)",
    "b5451aaa13ba": "Abenteurer",
    "d658d199540c": "0 XP",
    "42e2aa5470e7": " XP",
    "9717eb352337": "Experience Elixir",
    "3ba62c293ab6": "Gain 25% more XP for one individual deed per week.",
    "450864ab665b": "Einmal pro Woche 25 % mehr XP für eine Einzeltat.",
    "b6fbffaeb18a": " guild-shop",
    "5b3e5f590e60": "Gildex",
    "356db5eb31f6": " Gildex",
    "198fb678c812": "Guild statistics",
    "dbbcc055fb26": "Bestätigte Heldentaten",
    "5b11fe2f04f5": "Gildex verdient",
    "32d823725418": "Gildex earned",
    "15a3179e1e7c": "Heldentaten gegenüber dem vorherigen gleich langen Zeitraum:",
    "bae279e8bf55": "Gezählt ab Bestätigung, Zeitgrenzen in UTC. Historische Leistungen bleiben bei der damaligen Gilde.",
    "eda3a54706dc": "Counted from approval, with UTC period boundaries. Historical contributions stay with their original guild.",
    "84283337e247": "Heldentaten im Zeitverlauf",
    "71bcfe99e01b": "In diesem Zeitraum wurden noch keine Heldentaten bestätigt.",
    "7bd7d6d2efe7": "Aktive Mitglieder im Verhältnis zur gesamten Gilde",
    "b5cacdba5528": "Active members compared with the whole guild",
    "5f9d50483c1f": "Aktiv: mindestens eine bestätigte Einzelaktion für die Gilde oder Teilnahme an einer bestätigten Gruppenaktion. Gruppenteilnahmen zählen je Aktion, auch von ehemaligen Mitgliedern.",
    "4c6cf7cc1111": "Active: at least one approved individual deed for this guild or participation in an approved group deed. Participations count per deed, including former members.",
    "238c6eef4ba3": "Mit eurer ersten bestätigten Heldentat erscheint hier eure Wirkung nach Kategorien.",
    "3eb20d7dca1d": "Jede Heldentat zählt einmal, unabhängig von ihrer Teilnehmerzahl.",
    "325ba8c1e5d9": "Gildex & Ausbau",
    "f4e4094a94ea": "Gildex & development",
    "90d3ccca50df": "Gildex-Einnahmen und Ausgaben im gewählten Zeitraum",
    "ee36e9ddce32": "Gildex earned and spent in the selected period",
    "2f1d49da1e23": "Direkt beigetragene Gildex",
    "06097c96531f": "Directly contributed Gildex",
    "4d7fdae14b17": "Gruppenbelohnungen gehören der Gilde und werden hier nicht auf einzelne Mitglieder aufgeteilt.",
    "fd5c00369a49": "Group rewards belong to the guild and are not divided among individual members here.",
    "3e637b9d2de6": "Unlock the Trophy Room in the Gildex shop to open this gallery.",
    "982a1365d123": "Schaltet den Trophäenraum im Gildex-Shop frei, um diese Galerie zu öffnen.",
    "9cb479db5d4b": "Guild legacy",
    "73d8a14f8596": "Vermächtnis der Gilde",
    "dc596278d9f5": "A lasting record of the guild’s verified deeds and the members who accomplished them together.",
    "ec8d38bd7fe7": "Loading the guild’s achievements…",
    "80572bae1749": "Lade die Erfolge der Gilde…",
    "f5edf45aeade": "Unlock Group Good Deeds in the Gildex to start creating shared achievements.",
    "230b5c30d1bf": "Schaltet Gruppenaktionen im Gildex frei, um gemeinsame Erfolge zu schaffen.",
    "9efd79edc63b": "Wappen gestalten",
    "6722387741d7": "Wappen-Baukasten (Elemente)",
    "b4b39cdd92fe": "Wappenschmiede Freigeschaltet",
    "2e83774788fc": "Zufällige Wappenkombination",
    "3f12c55949e4": "Wappen Live-Vorschau",
    "2ffc7869e9b2": "Heraldisches Gildenwappen",
    "3d87aefea2a1": "Wappenschmiede Preview",
    "419dedf5e19c": "This crest uses exclusive forge elements. Unlock the Advanced Forge in the Guild Treasury shop with Gildex to apply it.",
    "584aea7f9abe": "Dieses Wappen nutzt exklusive Schmiede-Elemente. Schalte die \"Erweiterte Wappenschmiede\" im Gilden-Shop mit Gildex frei, um es dauerhaft zu speichern.",
    "831cefa91ceb": "Open Gildex Treasury",
    "0122936e8034": "Zur Gildex-Schatzkammer",
    "c36f48b7d236": "Klassische Standard-Wappen",
    "d2b13ba3aa87": "Wähle eine bewährte Standard-Kombination oder wechsle zum Wappen-Baukasten für individuelle Elemente.",
    "2f03025fd913": "In der Vorschau ziehen oder die Regler verwenden. Änderungen werden im Wappen gespeichert.",
    "2dd43870a02b": "Krone, Ritterhelm, Flamme oder Zinnen auf dem Wappen:",
    "111aabea36e8": "Lower base finish, guild ribbon banner, or gem pendant:",
    "0abdafe40412": "Unterer Wappenabschluss, Gilden-Banner oder Quaste:",
    "c6c2f4224b32": "Wähle den metallischen Glanz und die Farbtönung des Wappens:",
    "f1e9205cbb92": "Wappenschmiede",
    "168aad3e9812": "XP",
    "a9127cc07e92": "XP-Hilfe und Beispiele",
    "6a389d6c728d": " Karma",
    "6b2f2ecdd84a": " world-karma--stages",
    "eeafe73f02c8": "Höchste XP",
    "3b3f1e54984f": "Niedrigste XP",
    "f0a96bd6bf15": "Guild Master",
    "8bc9c6dd8644": " % XP",
    "687dfd0ceeee": "Gilde:",
    "e3e062929a2f": "Failed to apply emblem during guild creation",
    "31ba47f1fae3": "Taverne",
    "08db035d1806": "Gildenruhm und Aktivität sind derzeit nicht verfügbar.",
    "845d8127c1b4": "Gildenruhm und Aktivität konnten nicht geladen werden.",
    "a0a2ab9585a4": "Gildenhaus konnte nicht geladen werden.",
    "222a24fd9aa5": "Gilden-Neuigkeiten konnten nicht geladen werden.",
    "1c07813d09ea": "Gildenchat konnte nicht geladen werden.",
    "516773403e48": "Die angeforderte Gilde existiert nicht.",
    "21e1aeea2c1b": "Gildenverwaltung & Einstellungen",
    "f933fee4b73b": "Gildenruhm & Statistiken",
    "8e21174aef60": "Erfordert Gildex Freischaltung (Vize-Admin)",
    "867d4690e877": "Aus Gilde entfernen (Kick)",
    "5e0664b086b3": "Dauerhaft aus Gilde bannen",
    "ee84b83e2a24": "Du kannst nur einer Gilde gleichzeitig angehören.",
    "e47bab3c5826": "Erfahrungselixier: +25 % Gesamt- und Kategorie-XP bei Bestätigung, ohne XP-Kosten.",
    "a9096aac522c": "World Guild",
    "ab83d1ff771b": "Karma-Score",
    "55681e642a13": "Failed to fetch tavern feed",
    "00dc19d908f2": "Fehler beim Laden der Klassendaten.",
    "ccdf9223f7db": " neue Klasse",
    "8de641bae922": " Heldenklassen & Perks (",
    "504823c82e3b": "Klasse bearbeiten",
    "e6ee49712127": "Heldenklasse bearbeiten",
    "28b620216833": "Neue Heldenklasse anlegen",
    "a05731e81733": "Rolle / Klassentyp",
    "05b1b5e96c06": "Tailwind Farb-Klasse",
    "c58be06c1a93": "Klassen-Perk bearbeiten",
    "eff481858079": "Gesamt- und Kategorie-XP-Bonus",
    "90e7928d0517": "Party-Buff (Gruppen-XP)",
    "0f154384cef7": "Ehren-Karma Bonus (+1 Karma)",
    "11c40a51d425": "Karma-Erholung bei negativem Karma",
    "124911b8368c": "Kategorie-XP außerhalb der Zielkategorie",
    "db729f7363ab": "Erfahrungselixier (wöchentlich)",
    "031b655d8aaa": "Erholungs-Karma bis 0",
    "11fc673ba9d9": "Kategorie-XP-Bonus",
    "7558dba0c23d": "Gildex-Einzahlungsbonus",
    "8d7a465d4068": "Gruppen-Karma-Bonus",
    "70fddef742f8": "Wirkungswert (z.B. 0.20 = +20 %, 1 = +1 Slot/Karma)",
    "63f8d339cf42": "Tribunal Moderation",
    "54dcaca4c076": "Tribunal (",
    "75deb356299a": "Gilden (",
    "633ba960808f": "Zum Tribunal",
    "c6d1fc947dc9": "Im Gute-Taten-Tribunal prüfen",
    "c466734f5af1": "XP ×",
    "10c26d79140f": "XP-Vorschau konnte nicht geladen werden.",
    "8118de5cc29c": "XP wurden neu berechnet und die Differenz gebucht.",
    "c8db42d0bd0d": "XP konnten nicht neu berechnet werden.",
    "6f14360d1a0d": "Einstufung & XP-Vergabe",
    "3d62c442615b": "Passe Schwierigkeit und Komplexität an, um das verbindliche XP-Band festzulegen.",
    "1f7c933aceb6": "Basis-XP (Gruppe)",
    "26b475ca7301": "Kategorie-XP (Gruppe)",
    "a73feda6e2f7": " XP.",
    "c65a3b3858ce": " XP neu berechnen",
    "5d35f4fca941": "Gesamt-XP:",
    "cb874e449969": " · Kategorie-XP:",
    "b35858b78ad4": " XP, Kategorie",
    "c23e3acfe229": "XP-Hilfe",
    "78b14b08dc14": "Gute Tat oder Abenteurer…",
    "1443b9f2211c": "Alle XP-Bänder",
    "1698e4ae6293": "z. B. Taverne zum Drachen",
    "a677958fe6cc": "z. B. drachentaverne",
    "e00e689f3fc3": "info@drachentaverne.de",
    "0e6ec4da3067": "Genehmigte Bewerber erscheinen hier als aktive Tribunal-Moderatoren.",
    "f4a2115ad657": " XP /",
    "21591951cece": " XP)",
    "a190c9987e71": " XP ·",
    "e166da59b506": "Abenteurer (D)",
    "4c99fbbb2a76": "Beschreibe dein Angebot und wie Abenteurer es einlösen können (z.B. Zeige deinen Gildenpass an der Kasse oder nutze den Online-Code)...",
    "3937a00a22e5": "Standard: Für alle Abenteurer offen (ab Rang F)",
    "c7c3aa207e26": "Mindest-Gesamt-XP (optional)",
    "b001b3bb128a": "Mindest-Kategorie-XP",
    "438e079b21c4": "Mindest-Karma (optional)"
  },
  "effectDescriptions": {
    "CategoryRewardBonus": "{{percent}}% more total and category XP for approved good deeds in {{category}}.",
    "CategoryExperienceBonus": "{{percent}}% more category XP in {{category}}.",
    "GuildGildexContributionBonus": "{{percent}}% additional Gildex from your approved individual deeds for your guild.",
    "HeroicActionXpBonus": "{{percent}}% more XP for approved good deeds.",
    "PartyBuff": "{{percent}}% more group XP. Multiple identical class bonuses do not stack.",
    "KarmaBonus": "{{value}} additional karma per approved good deed, including group deeds.",
    "GroupKarmaBonus": "{{value}} additional karma for approved group deeds.",
    "KarmaRecoveryBonus": "{{value}} additional recovery karma while karma is negative.",
    "OtherCategoryExperienceBonus": "{{percent}}% more category XP outside {{category}}.",
    "WeeklyExperienceElixir": "Activate before an individual deed once per calendar week: {{percent}}% more total and category XP on approval.",
    "ClassKarmaRecovery": "While karma is negative, gain {{value}} additional recovery karma per approved deed, up to 0."
  },
  "unlocks": {
    "STAMMTISCH": {
      "name": "Regulars' Table & Chat",
      "description": "Unlocks the guild regulars' table and internal text chat for your guild members."
    },
    "DEPUTY_ADMIN": {
      "name": "Deputy Admin",
      "description": "Allows the guild leader to appoint deputies to help manage the guild."
    },
    "HALL_THEME_FOREST": {
      "name": "Forest Hall",
      "description": "Unlocks a beautiful forest theme for your guild hall view."
    },
    "GROUP_HEROIC_ACTIONS": {
      "name": "Group Good Deeds",
      "description": "Allows your guild to start joint good deeds and master larger quests as a team."
    },
    "GUILD_EMOJI_PACK": {
      "name": "Common Table Plus",
      "description": "Unlocks guild emotes, message reactions, pinned messages, and polls in guild chat."
    },
    "BANNER_FORGE_ADVANCED": {
      "name": "Advanced Banner Forge",
      "description": "Unlocks advanced editing and design options for your guild banner."
    },
    "TROPHY_ROOM": {
      "name": "Trophy Room"
    },
    "HALL_THEME_CELESTIAL": {
      "name": "Celestial Hall",
      "description": "The premium design! Unlocks the extremely rare and valuable celestial theme for your guild hall."
    },
    "EXP_BOOST_1": {
      "name": "XP Boost I",
      "description": "Passively grants all guild members +1% XP for their good deeds."
    },
    "EXP_BOOST_2": {
      "name": "XP Boost II",
      "description": "Passively grants all guild members +2% XP for their good deeds."
    },
    "EXP_BOOST_3": {
      "name": "XP Boost III",
      "description": "Passively grants all guild members +3% XP for their good deeds."
    },
    "EXP_BOOST_4": {
      "name": "XP Boost IV",
      "description": "Passively grants all guild members +4% XP for their good deeds."
    },
    "EXP_BOOST_5": {
      "name": "XP Boost V",
      "description": "Passively grants all guild members +5% XP for their good deeds."
    }
  },
  "legalContent": {
    "title": "Legal & Privacy",
    "updated": "Last updated: September 28, 2026",
    "tabs": [
      "Legal Notice",
      "Terms of Use",
      "Privacy"
    ],
    "sections": [
      [
        [
          "Service Provider",
          [
            "Goodvale",
            "Operator: Dipl. Ing. Thomas Johannes Trügler",
            "Contact: thomas@truegler.io",
            "Privacy: thomas@truegler.io"
          ]
        ]
      ],
      [
        [
          "1. Platform Purpose",
          [
            "Goodvale is a gamification platform for voluntary, self-reported good deeds. The tribunal reviews evidence and awards XP. XP represent game progress, are not transferable or redeemable for cash, and have no fixed monetary value."
          ]
        ],
        [
          "2. Voluntary Participation and No Concealed Work",
          [
            "Good deeds must not replace employment, work shifts, or ordinary commercial services. Guild good deeds must be voluntary, safe, and non-commercial. Partners may not direct assignments through guilds or good deeds and are responsible only for benefits they offer."
          ]
        ],
        [
          "3. Submissions and Evidence",
          [
            "Submitters must provide truthful information, hold the necessary rights to uploaded files, and avoid unnecessary third-party personal data. Dangerous, unlawful, or manipulated activities are not rewarded. External evidence links are prohibited."
          ]
        ],
        [
          "4. Tribunal and Appeals",
          [
            "The first assigned review fixes difficulty, complexity, and base XP within the configured range. The XP amount determines the number of independent reviews; high values also require an admin. The full quorum decides by majority. A tie triggers one additional review. Rejections may be appealed within the configured period."
          ]
        ],
        [
          "5. Group Good Deeds",
          [
            "Guild admins may announce voluntary group good deeds. Members register themselves and confirm actual participation only after the activity starts. Organizers allocate total XP among confirmed participants; no one may receive more than 50%. The tribunal reviews the allocation. Organizers remain responsible for permission, safety, and non-commercial execution."
          ]
        ],
        [
          "5a. Gildex",
          [
            "Gildex are non-purchasable, non-transferable and non-redeemable internal guild progression points with no monetary value. They are generated in addition to player XP from a configurable share of verified base XP and may be used exclusively for internal guild decorations and convenience features. They are not accepted by partners or outside Goodvale."
          ]
        ],
        [
          "6. Partner Offers",
          [
            "Partners configure unlocks based on rank, level, total XP, category progress, or a verified system good deed. XP are not consumed on redemption. Redemption requires a short-lived signed QR pass, and each QR session can be used only once. The partner is responsible for the benefit and its availability."
          ]
        ],
        [
          "7. Classes, Boosts, and Karma",
          [
            "Class and talent bonuses affect game values only. The alchemist’s experience elixir is free and available once per calendar week. Submission consumes the charge even if later rejected or withdrawn. Karma remains a separate trust and conduct value."
          ]
        ],
        [
          "8. Security and Enforcement",
          [
            "Reusing evidence, QR manipulation, deception, harassment, or circumvention may lead to rejection, restrictions, or suspension."
          ]
        ],
        [
          "9. Liability",
          [
            "Goodvale reviews platform evidence but does not guarantee on-site safety, permits, or fulfillment of partner offers. Mandatory statutory liability remains unaffected."
          ]
        ],
        [
          "10. Eligibility, Registration and Contract",
          [
            "Goodvale is for people aged 18 and over. By registering you confirm that you are an adult and accept these terms. The service contract begins when the account is activated; partner accounts require separate approval. Provide accurate information, protect your credentials and report suspected account misuse. Registration does not guarantee particular partner offers or rewards."
          ]
        ],
        [
          "11. Content Rights",
          [
            "Your content remains yours. You grant Goodvale only the non-exclusive rights necessary to store, technically process, display within your chosen audience and review it. Advertising use beyond this requires separate permission. Upload only content for which you have the necessary rights. Rights end on deletion except insofar as lawful retention or pending proceedings require them."
          ]
        ],
        [
          "12. Termination and Changes",
          [
            "You may stop using the service and delete your account in your profile or terminate by emailing thomas@truegler.io. Guild leaders may first need to transfer leadership or dissolve the guild; your right to terminate remains unaffected. Immediate suspension for serious cause, including significant unlawful activity or security threats, remains possible.",
            "Material changes to these terms will be clearly announced before taking effect. Where consent is required, we request it expressly; silence is not consent. You may terminate before changes take effect. Maintenance and development may affect availability and game rules; mandatory rights remain unaffected."
          ]
        ],
        [
          "13. Reporting Illegal Content",
          [
            "Users and authorities can contact thomas@truegler.io in German or English. For content reports, preferably use the subject “Content report” and provide the precise link or unique content identifier, reasons for suspected illegality and any supporting evidence. Include your name, email address and a statement that the information is accurate and complete to the best of your knowledge; statutory exceptions to identification requirements remain applicable.",
            "We acknowledge receipt, review reports diligently and impartially, and communicate our decision and available remedies where contact details are available. Do not send unnecessary sensitive data. This contact point is not an emergency service."
          ]
        ],
        [
          "14. Moderation and Complaints",
          [
            "Illegal content, threats, harassment, disclosure of private third-party data, rights infringements and manipulated evidence are prohibited. Depending on severity, repetition and risk, content may be restricted or removed, submissions rejected and accounts temporarily or permanently suspended. Automated checks assist detection and assignment; disputed measures receive human review.",
            "Where legally permitted, affected users receive understandable reasons covering the relevant circumstances, rule, scope, duration and complaint route. You may challenge moderation measures free of charge within six months by emailing thomas@truegler.io with the subject “Moderation complaint”, identifying the decision and your objections. An authorized person reviews the complaint, not solely an automated system. Incorrect measures are corrected. The in-app tribunal appeal procedure additionally applies to deed and XP decisions. Statutory judicial and out-of-court remedies remain unaffected."
          ]
        ],
        [
          "15. Applicable Law",
          [
            "Austrian law applies. Mandatory consumer protections in your country of habitual residence remain applicable where required by law. Statutory jurisdiction is not restricted."
          ]
        ]
      ],
      [
        [
          "1. Controller",
          [
            "The controller is the operator named in the legal notice. Privacy requests: thomas@truegler.io."
          ]
        ],
        [
          "2. Data and Purposes",
          [
            "We process account and profile data, progress, karma, guild membership, Gildex ledger entries and unlocks, submissions, tribunal decisions, appeals, partner redemptions, messages, push subscriptions, and security/access logs. Purposes include account administration, gameplay, abuse prevention, communication, and evidence review."
          ]
        ],
        [
          "3. Legal Bases",
          [
            "Account administration, communication, submission reviews and benefit redemption rely on Article 6(1)(b) GDPR insofar as necessary for those services. Optional Umami statistics and Sentry browser diagnostics each require separate consent under Article 6(1)(a). Security logs, server diagnostics and abuse prevention serve our legitimate interests in safe and fair operation under Article 6(1)(f). Statutory retention and disclosure duties rely on Article 6(1)(c).",
            "An email address, credentials and the information required for your role are necessary to provide an account. Optional information and tracking consent are not required for general use. Consent may be withdrawn prospectively at any time without affecting the lawfulness of prior processing."
          ]
        ],
        [
          "4. Evidence Privacy",
          [
            "Evidence you choose to submit is processed to perform the review you request (Article 6(1)(b) GDPR). The upload confirmation acknowledges the evidence rules; it is not blanket consent to arbitrary processing. Files are encrypted outside public web directories and accessible to the submitter, assigned reviewers and authorized administrators. Access is logged.",
            "Upload only necessary evidence. Obscure uninvolved people, number plates and private addresses. Do not upload health records, identity documents or other sensitive information about yourself or others. Confirming the upload does not establish rights or a lawful basis for third-party data.",
            "Direct deletion of individual evidence is restricted once review starts to preserve the integrity of the proceedings. You may still request erasure, restriction or withdrawal of your submission at thomas@truegler.io. Requests are assessed individually; continued retention requires a valid legal basis, such as necessary legal defence. The technical restriction does not override statutory rights."
          ]
        ],
        [
          "5. Recipients and Processors",
          [
            "Data is disclosed only to technically or operationally necessary recipients, such as contracted hosting, push, or security providers. Partners see only data needed to verify eligibility and redemption."
          ]
        ],
        [
          "5a. Hetzner – Hosting",
          [
            "We use Hetzner Online GmbH for the hosting infrastructure of Goodvale. This involves processing data stored to operate the platform and technical connection and access data, including IP addresses, timestamps, and requested resources. This supports platform availability and security on the basis of contract performance and our legitimate interests in secure operation."
          ],
          "https://www.hetzner.com/legal/privacy-policy/"
        ],
        [
          "5b. Sentry – Error Diagnostics",
          [
            "Sentry helps detect and resolve technical errors. Processing may include error messages, stack traces, technical browser, device and request data, and performance data. Browser error reporting is enabled only with your consent, which you can withdraw through the tracking settings. Automatic transmission of additional personal data is disabled in the browser. Server-side error and performance diagnostics operate separately on the basis of our legitimate interests in maintaining a secure and reliable service."
          ],
          "https://sentry.io/privacy/"
        ],
        [
          "5c. Umami – Usage Statistics",
          [
            "With your consent, Umami collects page views and technical usage data, such as visited URLs, referrers, and browser and device information. We use these statistics to understand and improve the use and usability of Goodvale. You can disable collection at any time in the tracking settings. Processing takes place through the Umami instance configured for Goodvale."
          ],
          "https://docs.umami.is/"
        ],
        [
          "5d. Firebase – Push Notifications",
          [
            "We use Google Firebase Cloud Messaging for Android push notifications. This involves device registration tokens, technical delivery data, and notification data. Goodvale sends a generic new-notification message plus a type and reference identifier, rather than chat message text. Delivery follows activation and device permission. You can disable push notifications in your device settings."
          ],
          "https://firebase.google.com/support/privacy"
        ],
        [
          "5e. Resend – Email Delivery",
          [
            "Resend delivers transactional account emails, including email verification and password resets. Processing includes the recipient address, email contents including verification or reset links, and technical sending and delivery data. This supports account administration and security on the basis of contract performance and our legitimate interests in protecting user accounts."
          ],
          "https://resend.com/legal/privacy-policy"
        ],
        [
          "5f. Maps and Location",
          [
            "Maps load tiles from the OpenStreetMap Foundation. Opening a map sends your IP address, technical request data and the requested map area to its servers to display the requested map and support our legitimate interest in functional location features. The map area may indicate the location being viewed.",
            "Device location sharing is optional and requires device permission. Manually entered locations, public guild or partner locations and optional GPS evidence are processed for the relevant feature. Publicly entered locations are visible to others; GPS evidence forms part of a protected submission."
          ],
          "https://osmfoundation.org/wiki/Privacy_Policy"
        ],
        [
          "5g. Apple Push on iOS",
          [
            "iOS notifications use Apple Push Notification service (APNs), processing device tokens, technical delivery data, a generic notification and its type and reference identifier. This requires activation and device permission, which you may revoke in device settings."
          ],
          "https://www.apple.com/legal/privacy/"
        ],
        [
          "5h. Visibility and Recipients within Goodvale",
          [
            "Public profile details such as username, selected profile image, biography and displayed progress may be shown to other users or visitors. Do not publish confidential details there. Guild content is visible according to its public or members-only feature. Direct messages are intended for conversation participants and guild chats for members. Authorized administrators may access data where necessary for operation, support or investigation of specific abuse reports.",
            "Tribunal reviewers access protected evidence only as part of an assignment. Partners receive the eligibility and redemption information required for a benefit. Submitting information for review does not by itself make it public."
          ]
        ],
        [
          "5i. Regions and International Transfers",
          [
            "Hetzner hosting and our self-hosted Umami instance are located in Europe. For external services we use available, configured EU data regions. EU storage does not automatically exclude access or processing outside the EEA by international providers or subprocessors, particularly for global push and email services.",
            "Transfers outside the EEA require an adequacy decision under Article 45 GDPR or appropriate safeguards under Article 46, such as EU Standard Contractual Clauses and supplementary measures where necessary. EU-US Data Privacy Framework certification can be relied upon only where the specific recipient and processing are covered. For information on the recipients and safeguards applicable to your data and copies of safeguards, contact thomas@truegler.io."
          ]
        ],
        [
          "6. Retention",
          [
            "Account data is stored for the life of the account. Account deletion removes or clears contact details, profile content, locations, evidence, push registrations, associated direct messages and your guild chat messages. Pending submissions are withdrawn. Pseudonymized review and ledger records may remain and are still personal data where attribution is possible.",
            "The system provides a standard evidence retention period of 90 days after the final decision, at least until seven days after the applicable appeal period ends. Pending proceedings and appeals must be taken into account. Any necessary deviation requires a specific procedural purpose or legal basis.",
            "Security, diagnostic, delivery and review logs are retained according to the need to resolve errors, establish delivery, investigate a specific abuse incident or defend claims. Personal data no longer needed must be erased or genuinely anonymized; closed cases do not justify indefinite retention. Statutory retention duties apply where relevant. Local preferences remain until changed or browser storage is cleared."
          ]
        ],
        [
          "7. Your Rights",
          [
            "You can download a machine-readable copy in your profile and anonymize your account. Where legally applicable, you also have rights of access, rectification, erasure, restriction, portability, objection, and complaint to the Austrian Data Protection Authority."
          ]
        ],
        [
          "8. Account Anonymization",
          [
            "Self-service deletion removes contact data and evidence files and disables access. Review, ledger, and security records may remain pseudonymized where required for system integrity or legal obligations."
          ]
        ],
        [
          "9. Rights, Objections and Contact",
          [
            "Contact thomas@truegler.io or the postal address in the legal notice to request access, rectification, erasure, restriction, portability or withdrawal of consent. You may object to processing based on legitimate interests on grounds relating to your particular situation. We generally respond within one month and explain any legally permitted extension. You may complain to the Austrian Data Protection Authority."
          ],
          "https://dsb.gv.at/"
        ],
        [
          "10. Local Storage and Automated Rules",
          [
            "Local browser storage supports login, language, appearance and privacy choices. Optional Umami statistics and Sentry browser diagnostics are separately selectable and disabled by default. Refusal does not affect general use. Change your choices using the settings below.",
            "XP, unlocks, karma effects and anti-cheat checks are partly calculated by rules affecting game progress and review assignments. Assigned people make tribunal decisions. Disputed results may be referred for human review using the appeal feature or thomas@truegler.io."
          ]
        ]
      ]
    ]
  },
  "classAvailability": {
    "bonus": "Experience elixir"
  }
}
